import React, { useEffect, useState, useRef, useContext, useCallback } from 'react';
import { Row, Col, Tooltip, } from 'reactstrap';
import DayTime from '../../../common/DayTimeWrapper'
import { CBCTypeId, defaultPageSize, EMPTY_DATA, EXCHNAGERATE, RMDOMESTIC, RMIMPORT, BOPIMPORT, RAWMATERIALAPPROVALTYPEID, RAWMATERIALINDEX, ZBCTypeId, GET_INDEXED_RM_FOR_SIMULATION } from '../../../../config/constants';
import NoContentFound from '../../../common/NoContentFound';
import { checkForDecimalAndNull, checkForNull, getConfigurationKey, loggedInUserId, searchNocontentFilter, userDetails, preciseAdd, preciseSubtract, preciseMultiply, preciseDivide } from '../../../../helper';
import Toaster from '../../../common/Toaster';
import { editRMIndexedSimulationData, getCommodityDetailForSimulation, draftSimulationForRMMaster, runVerifySimulation, updateSimulationRawMaterial, runSimulationOnRawMaterial, setEffectiveDateRMNonIndexation } from '../../actions/Simulation';
import { Fragment } from 'react';
import { TextFieldHookForm } from '../../../layout/HookFormInputs';
import DatePicker from "react-datepicker";
import { useForm, Controller } from 'react-hook-form'
import RunSimulationDrawer from '../RunSimulationDrawer';
import VerifySimulation from '../VerifySimulation';
import { useDispatch, useSelector } from 'react-redux';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';
import _, { debounce } from 'lodash'
import { VBC, ZBC } from '../../../../config/constants';
import { PaginationControl, PaginationWrapper } from '../../../common/commonPagination';
import WarningMessage from '../../../common/WarningMessage';
import { getMaxDate } from '../../SimulationUtils';
import PopupMsgWrapper from '../../../common/PopupMsgWrapper';
import { APPLICABILITY_RAWMATERIAL_SIMULATION, APPLICABILITY_RM_SIMULATION, FORGING, RM_IMPACT_DOWNLOAD_EXCEl, RM_IMPACT_DOWNLOAD_EXCEl_IMPORT } from '../../../../config/masterData';
import ReactExport from 'react-export-excel';
import { createMultipleExchangeRate } from '../../../masters/actions/ExchangeRateMaster';
import LoaderCustom from '../../../common/LoaderCustom';
import { reactLocalStorage } from 'reactjs-localstorage';
import { simulationContext } from '..';
import PriceComparisonSpan from '../../../common/PriceComparisonSpan';
import { setCommodityDetails } from '../../../masters/actions/Indexation';
import CommoditySimulationDrawer from './CommoditySimulationDrawer';
import AddOtherCostDrawer from '../../../masters/material-master/AddOtherCostDrawer';
import SimulationApproveReject from '../../../costing/components/approval/SimulationApproveReject';
import { Redirect } from 'react-router-dom/cjs/react-router-dom';
import CustomCellRenderer from '../../../rfq/CommonDropdown';
import { useLabels } from '../../../../helper/core';
import AddConditionCosting from '../../../costing/components/CostingHeadCosts/AdditionalOtherCost/AddConditionCosting';
import { updateCostValue } from '../../../common/CommonFunctions';
import { beforeSaveCell as validateRevisedRate, validateAndFormatValue, resetFieldToLastValidValue, valueSetter as valueSetterFromHelper } from '../../../../helper/simulationValidation';
import useRowChangeTracker from './UseRowChangeTracker';

const gridOptions = {

};

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function RMIndexationSimulation(props) {

    const { showEditMaster, handleEditMasterPage, showCompressedColumns, render } = useContext(simulationContext) || {};


    const { list, isbulkUpload, rowCount, technology, master, isImpactedMaster, costingAndPartNo, tokenForMultiSimulation, technologyId, isApprovalSummary, isCostingSimulation, simulationData } = props
    const [showRunSimulationDrawer, setShowRunSimulationDrawer] = useState(false)
    const [showverifyPage, setShowVerifyPage] = useState(false)
    const [token, setToken] = useState('')
    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [textFilterSearch, setTextFilterSearch] = useState('')
    const [isDisable, setIsDisable] = useState(false)
    const [effectiveDate, setEffectiveDate] = useState('');
    const [maxDate, setMaxDate] = useState('');
    const [isEffectiveDateSelected, setIsEffectiveDateSelected] = useState(false);
    const [isWarningMessageShow, setIsWarningMessageShow] = useState(false)
    const [titleObj, setTitleObj] = useState({})
    const [disableSendForApproval, setDisableSendForApproval] = useState(false)
    const [sendForApprovalMessage, setSendForApprovalMessage] = useState('')
    const [popupMessage, setPopupMessage] = useState('There is no changes in scrap rate Do you want to continue')
    const gridRef = useRef();
    const [noData, setNoData] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false)
    const [basicRateviewTooltip, setBasicRateViewTooltip] = useState(false)
    const [scrapRateviewTooltip, setScrapRateViewTooltip] = useState(false)
    const [isLoader, setIsLoader] = useState(false)
    const [isScrapUOMApplyTemp, setIsScrapUOMApplyTemp] = useState(false)
    const [openCommodityDrawer, setOpenCommodityDrawer] = useState(false)
    const [editIndex, setEditIndex] = useState(false)
    const [commodityDetailForRow, setCommodityDetailForRow] = useState([])
    const [otherCostDetailForRow, setOtherCostDetailForRow] = useState([])
    const [openOtherCostDrawer, setOpenOtherCostDrawer] = useState(false)
    const [isViewFlag, setIsViewFlag] = useState(false)
    const [totalBasicRate, setTotalBasicRate] = useState('')
    const [netCostWithoutConditionCost, setNetCostWithoutConditionCost] = useState('')
    const [rowData, setRowData] = useState([])
    const [simulationId, setSimulationId] = useState('')
    const [isRunSimulationClicked, setRunSimulationClicked] = useState(false)
    const [isApprovalDrawer, setIsApprovalDrawer] = useState(false)
    const [simulationTechnologyId, setSimulationTechnologyIdState] = useState('')
    const [simulationHeadId, setSimulationHeadId] = useState('')
    const [tokenNumber, setTokenNumber] = useState('')
    const [showApprovalHistory, setShowApprovalHistory] = useState(false)
    const [isIndexedRM, setIsIndexedRM] = useState(false)
    const [openConditionCostDrawer, setOpenConditionCostDrawer] = useState(false)
    const [conditionCostDetailForRow, setConditionCostDetailForRow] = useState([])
    const [rowIndex, setRowIndex] = useState('')
    const [isSaving, setIsSaving] = useState(false);
    const [isApiSaving, setIsApiSaving] = useState(false);
    const [isOtherCostSaving, setIsOtherCostSaving] = useState(true)
    const [isConditionCostSaving, setIsConditionCostSaving] = useState(true)
    const [sourceVendorData, setSourceVendorData] = useState([])
    const [nonSourceVendorData, setNonSourceVendorData] = useState([])
    const [showSourceVendorTable, setShowSourceVendorTable] = useState(false)
    const [showNonSourceVendorTable, setShowNonSourceVendorTable] = useState(false)
    const [isSourceVendorDrawer, setIsSourceVendorDrawer] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(defaultPageSize);
    const [sourceCurrentPage, setSourceCurrentPage] = useState(0);
    const [sourcePageSize, setSourcePageSize] = useState(defaultPageSize);
    const [sourceGridApi, setSourceGridApi] = useState(null);
    const { register, control, setValue, formState: { errors }, } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
    })
    const {
        state: { hasUnsavedChanges, editingRowIndex, editableRowId },
        beginEdit,
        onValueChange,
        rowStyle,
        saveSucceeded,
        resetAll,
        markEditing,
    } = useRowChangeTracker({
        getRowId: (row) => row?.OldRawMaterialId,
        makeSnapshot: (row) => ({
            NewBasicRatePerUOM: checkForNull(row?.NewBasicRatePerUOM),
            NewScrapRate: checkForNull(row?.NewScrapRate),
            NewScrapRatePerScrapUOM: checkForNull(row?.NewScrapRatePerScrapUOM),
            NewFromDate: row?.NewFromDate ? DayTime(row?.NewFromDate).format('YYYY-MM-DD') : null,
            NewToDate: row?.NewToDate ? DayTime(row?.NewToDate).format('YYYY-MM-DD') : null,
            NewEffectiveDate: row?.NewEffectiveDate ? DayTime(row?.NewEffectiveDate).format('YYYY-MM-DD') : null,
            NewOtherNetCost: checkForNull(row?.NewOtherNetCost),
            NewNetConditionCost: checkForNull(row?.NewNetConditionCost),
            NewNetCostWithoutConditionCost: checkForNull(row?.NewNetCostWithoutConditionCost),
        }),
        onBlockSwitch: ({ fromIndex, toIndex, editingRowId }) => {
            const dataArr = tableData || [];
            const findRowById = (id) => id ? dataArr.find(r => (
                r?.OldRawMaterialId === id || r?.RawMaterialId === id || r?.NewRawMaterialId === id
            )) : null;

            const fromRow = findRowById(editingRowId);
            const fromName = fromRow?.RawMaterialName || fromRow?.RawMaterialCode || 'selected raw material';

            Toaster.warning(`Please save changes in ${fromName} before editing another row.`);
        },
        logPrefix: '[RMIndexation]',
    });

    // Helper function to get dynamic row name for toasters
    const getRowName = (row) => {
        return row?.RawMaterialName || row?.RawMaterialCode || 'raw material';
    };

    const { technologyLabel, vendorLabel } = useLabels();
    const dispatch = useDispatch()

    const currencySelectList = useSelector(state => state.comman.currencySelectList)
    const { selectedMasterForSimulation, exchangeRateListBeforeDraft, indexedRMForSimulation } = useSelector(state => state.simulation)
    const simulationApplicability = useSelector(state => state.simulation.simulationApplicability)
    const rmIndexedSimulationSummaryData = useSelector(state => state?.simulation?.simulatedRawMaterialSummary?.SimulationRawMaterialDetailsResponse)

    const { commodityDetailsArray } = useSelector((state) => state.indexation)
    const { filteredRMData } = useSelector(state => state.material)
    const selectedEffectiveDate = useSelector((state) => state.simulation.selectedEffectiveDate);

    const tableData = isApprovalSummary ? rmIndexedSimulationSummaryData : isCostingSimulation ? list : indexedRMForSimulation
    const masterList = useSelector(state => state.simulation.masterSelectListSimulation)
    const RawMaterialsEffectiveDate = useSelector((state) => state.simulation.rawMaterialsEffectiveDate);


    const columnWidths = {
        // Base column widths - used for compressed/expanded views
        COMPRESSED_WIDTH: 50,
        STANDARD_WIDTH: {
            SMALL: 80,
            MEDIUM: 120,
            LARGE: 160,
            EXTRA_LARGE: 190
        },

        // Main Information Columns
        CostingHead: showCompressedColumns ? 50 : 120,
        RawMaterialName: showCompressedColumns ? 50 : 120,
        RawMaterialGradeName: showCompressedColumns ? 50 : 120,
        RawMaterialSpecificationName: showCompressedColumns ? 50 : 110,
        RawMaterialCode: showCompressedColumns ? 50 : 110,
        RawMaterialCategoryName: showCompressedColumns ? 50 : 80,

        // Vendor/Customer Related
        VendorCode: showCompressedColumns ? 50 : 160,
        CustomerName: showCompressedColumns ? 50 : 160,
        SourceVendorName: showCompressedColumns ? 50 : 135,
        SourceVendorCode: showCompressedColumns ? 50 : 200, // For SourceVendorAssociatedAsRawMaterialVendors

        // Plant & Technology
        PlantCode: showCompressedColumns ? 50 : 160,
        TechnologyName: showCompressedColumns ? 50 : 125,

        // Measurement Units
        UnitOfMeasurementName: showCompressedColumns ? 50 : 100,
        ScrapUnitOfMeasurement: showCompressedColumns ? 50 : 150,

        // Reference Numbers
        CostingNumber: showCompressedColumns ? 50 : 160,
        PartNumber: showCompressedColumns ? 50 : 190,

        // Dates
        EffectiveDate: showCompressedColumns ? 50 : 140,
        OldFromDate: showCompressedColumns ? 50 : 120,
        NewFromDate: showCompressedColumns ? 50 : 120,
        OldToDate: showCompressedColumns ? 50 : 120,
        NewToDate: showCompressedColumns ? 50 : 120,

        // Rates and Costs
        BasicRate: {
            existing: showCompressedColumns ? 80 : 100,
            revised: showCompressedColumns ? 90 : 100,
            group: 200
        },
        ScrapRate: {
            existing: showCompressedColumns ? 40 : 70,
            revised: showCompressedColumns ? 50 : 90,
            group: 200,
            perScrapUOM: showCompressedColumns ? 50 : 90
        },

        BasicPrice: {
            existing: showCompressedColumns ? 80 : 100,
            revised: showCompressedColumns ? 90 : 100,
            group: 200
        },
        OtherCost: {
            existing: showCompressedColumns ? 80 : 80,
            revised: showCompressedColumns ? 90 : 90,
            group: 200
        },
        NetCost: {
            existing: showCompressedColumns ? 60 : 70,
            revised: showCompressedColumns ? 70 : 90,
            group: 200
        },
        ConditionCost: {
            existing: showCompressedColumns ? 60 : 80,
            revised: showCompressedColumns ? 70 : 90,
            group: 200
        },

        // Currency Related
        Currency: {
            standard: 140,
            withConversion: 240
        },

        // Action Columns
        actionColumn: 80
    };

    useEffect(() => {
        if (isApprovalSummary) {
            setIsViewFlag(true)
        }
    }, [isApprovalSummary])


    useEffect(() => {

        if (!isSaving) return;

        if (indexedRMForSimulation && indexedRMForSimulation?.[rowIndex] && !isImpactedMaster && (isOtherCostSaving || isConditionCostSaving)) {
            let obj = indexedRMForSimulation?.[rowIndex]
            obj.otherCostTableData = obj.NewRawMaterialOtherCostDetails || []
            obj.conditionTableData = obj.NewRawMaterialConditionsDetails || []

            const updatedObjOtherCost = updateCostValue(false, obj, totalBasicRate, true, true)
            obj.NewRawMaterialOtherCostDetails = updatedObjOtherCost?.tableData
            obj.NewOtherNetCost = updatedObjOtherCost?.formValue?.value
            obj.NewOtherNetCostConversion = updatedObjOtherCost?.formValue?.value
            obj.NewOtherNetCostLocalConversion = updatedObjOtherCost?.formValue?.value

            const basicPrice = preciseAdd(checkForNull(totalBasicRate), checkForNull(updatedObjOtherCost?.formValue?.value))

            const updatedObjConditionCost = updateCostValue(true, obj, basicPrice, true, true)
            obj.NewRawMaterialConditionsDetails = updatedObjConditionCost?.tableData
            obj.NewNetConditionCost = updatedObjConditionCost?.formValue?.value
            obj.NewConditionNetCostConversion = updatedObjConditionCost?.formValue?.value
            obj.NewConditionNetCostLocalConversion = updatedObjConditionCost?.formValue?.value


            obj.NewNetLandedCost = preciseAdd(checkForNull(totalBasicRate), checkForNull(updatedObjOtherCost?.formValue?.value), checkForNull(updatedObjConditionCost?.formValue?.value))
            obj.NewNetCostWithoutConditionCost = preciseAdd(checkForNull(totalBasicRate), checkForNull(updatedObjOtherCost?.formValue?.value))
            obj.NewNetLandedCostConversion = preciseAdd(checkForNull(totalBasicRate), checkForNull(updatedObjOtherCost?.formValue?.value), checkForNull(updatedObjConditionCost?.formValue?.value))
            obj.NewNetLandedCostLocalConversion = preciseAdd(checkForNull(totalBasicRate), checkForNull(updatedObjOtherCost?.formValue?.value), checkForNull(updatedObjConditionCost?.formValue?.value))

            setNetCostWithoutConditionCost(obj.NewNetCostWithoutConditionCost)
            indexedRMForSimulation[rowIndex] = obj
            setIsLoader(true)
            setTimeout(() => {
                setIsLoader(false)
                // setIsSaving(false) // Reset saving state
            }, 200);
        }
    }, [totalBasicRate, isOtherCostSaving, isConditionCostSaving, otherCostDetailForRow, indexedRMForSimulation, /* isSaving */]);
    useEffect(() => {
        if (selectedMasterForSimulation?.value === EXCHNAGERATE) {
            dispatch(createMultipleExchangeRate(exchangeRateListBeforeDraft, currencySelectList, props?.effectiveDate, res => {
                if (!res?.status && !res?.error) {
                    setValueFunction(true, res);
                }
            }))
        } else {
            setValueFunction(false, []);
        }
    }, [])
    const setValueFunction = (check, res) => {

        const filteredMasterId = masterList?.find(item => item?.Text === "Raw Materials")?.Value;
        if (!props?.isFromApprovalListing && !isApprovalSummary && !isCostingSimulation) {
            setIsLoader(true)
            let rawMaterialIds = isCostingSimulation ? props?.list && props?.list?.length > 0 && props?.list.map(item => item.NewRawMaterialIndexationDetails.RawMaterialId) : props?.list && props?.list?.length > 0 && props?.list.map(item => item.RawMaterialId)
            let obj = {
// when implemented bulk upload from BE we will modify the payload un comment the commented
                "RawMaterialIds": rawMaterialIds,
                // "RawMaterialIds": props?.isbulkUpload ? props?.list : rawMaterialIds,
                "TechnologyId": null,
                "SimulationTechnologyId": check ? EXCHNAGERATE : selectedMasterForSimulation?.value,
                "EffectiveDate": props?.effectiveDate && DayTime(props.effectiveDate).isValid() ? DayTime(props.effectiveDate).format('YYYY-MM-DD HH:mm:ss') : null,
                "LoggedInUserId": loggedInUserId(),
                "SimulationHeadId": RAWMATERIALAPPROVALTYPEID,
                "IsSimulationWithOutCosting": true,
                "IsExchangeRateSimulation": check,
                "SimulationExchangeRates": [],
                "ExchangeRateSimulationTechnologyId": filteredMasterId,
                // "IsRequestForBulkEdit": props?.isbulkUpload ? true : false
            }
            if (check) {
                obj.SimulationExchangeRates = res
                obj.IsExchangeRateSimulation = true
            }
            dispatch(draftSimulationForRMMaster(obj, (res) => {
                // Check if status is 204, not 200, or result is unsuccessful
                if (res?.data?.Status === 204 || res?.status === 204 || res?.status !== 200 || !res?.data?.Result) {
                    setIsLoader(false)
                    // Navigate back to listing page on error
                    if (props?.backToSimulation) {
                        props?.backToSimulation()
                    }
                    return;
                }

                let obj1 = {
                    SimulationId: res?.data?.Identity
                }
                setSimulationId(res?.data?.Identity)
                dispatch(editRMIndexedSimulationData(obj1, (res) => {

                    if (res?.data?.Result) {
                        setTimeout(() => {
                            setIsLoader(false)
                        }, 1000)

                    } else {
                        setIsLoader(false)
                    }
                }))

            }))
        }
    }
    useEffect(() => {

        if (props?.isFromApprovalListing && !isApprovalSummary && !isCostingSimulation) {
            let obj1 = {
                SimulationId: props?.simulationId
            }
            setIsLoader(true)
            setSimulationId(props?.simulationId)

            dispatch(editRMIndexedSimulationData(obj1, (res) => {

                if (res?.data?.Result) {
                    setTimeout(() => {
                        setEffectiveDate(res?.data?.Data?.EffectiveDate)
                        setRunSimulationClicked(true)
                        setIsViewFlag(true)
                        setTokenNumber(res?.data?.Data?.TokenNumber)
                        setSimulationTechnologyIdState(res?.data?.Data?.SimulationTechnologyId)
                        setSimulationHeadId(res?.data?.Data?.SimulationHeadId)
                        setIsLoader(false)
                        reactLocalStorage.setObject('isSaveSimualtionCalled', '')
                    }, 1000)

                } else {
                    setIsLoader(false)
                }
            }))
        }
    }, [props?.isFromApprovalListing])
    useEffect(() => {

        if (handleEditMasterPage) {
            handleEditMasterPage(showEditMaster, showverifyPage)
        }
    }, [showverifyPage])
    useEffect(() => {
        if (list && list.length > 0) {

            if (isIndexedRM) {

                window.screen.width >= 1921 && gridRef.current?.api?.sizeColumnsToFit();
                let tempList = [...list]
                let maxDate = getMaxDate(tempList)
                setMaxDate(maxDate?.NewRawMaterialIndexationDetails?.EffectiveDate)
            } else {

                window.screen.width >= 1921 && gridRef.current?.api?.sizeColumnsToFit();
                let tempList = [...list]
                let maxDate = getMaxDate(tempList)
                setMaxDate(maxDate?.EffectiveDate)
            }
        }

    }, [list, isIndexedRM])


    useEffect(() => {



        if (indexedRMForSimulation?.length > 0 || rmIndexedSimulationSummaryData?.length > 0 || list?.length > 0) {
            let isIndexedRM = false
            if (indexedRMForSimulation?.length > 0) {
                isIndexedRM = indexedRMForSimulation[0]?.IsIndexationDetails
            } else if (rmIndexedSimulationSummaryData?.length > 0) {
                isIndexedRM = rmIndexedSimulationSummaryData[0]?.IsIndexationDetails
            } else if (list?.length > 0) {
                isIndexedRM = list[0]?.IsIndexationDetails
            }
            setIsIndexedRM(isIndexedRM)
        }
    }, [indexedRMForSimulation, list, rmIndexedSimulationSummaryData])
    useEffect(() => {
        if (!isImpactedMaster) {
            list && list?.map(item => {
                setNetCostWithoutConditionCost(item.NewNetCostWithoutConditionCost)
            })
        }
    }, [])

    // useEffect to separate source and non-source vendor data
    useEffect(() => {
        // Use tableData instead of indexedRMForSimulation to handle all scenarios (list, indexedRMForSimulation, rmIndexedSimulationSummaryData)
        if (tableData && tableData.length > 0) {
            const sourceVendor = tableData.filter(item => item?.IsSourceVendor === true);
            const nonSourceVendor = tableData.filter(item => item?.IsSourceVendor !== true);

            setSourceVendorData(sourceVendor);
            setNonSourceVendorData(nonSourceVendor);
            setShowSourceVendorTable(sourceVendor.length > 0);
            setShowNonSourceVendorTable(nonSourceVendor.length > 0);

            // Update grid's total row count when data changes
            if (gridApi) {
                const totalRows = sourceVendor.length + nonSourceVendor.length;
                gridApi?.setRowCount?.(totalRows);

                // Ensure we don't exceed the total number of pages
                if (pageSize > 0 && totalRows > 0) {
                    const maxPage = Math.max(0, Math.ceil(totalRows / pageSize) - 1);
                    if (currentPage > maxPage) {
                        gridApi?.paginationGoToPage?.(maxPage);
                    }
                }
            }
        } else {
            setSourceVendorData([]);
            setNonSourceVendorData([]);
            setShowSourceVendorTable(false);
            setShowNonSourceVendorTable(false);

            if (gridApi) {
                gridApi?.setRowCount?.(0);
            }
        }
    }, [tableData, isOtherCostSaving, isConditionCostSaving, isSaving, gridApi, pageSize, currentPage]);

    // Refresh grid styling when row highlighting changes
    useEffect(() => {
        if (gridApi) {
            gridApi.refreshCells({ force: true });
        }
        if (sourceGridApi) {
            sourceGridApi.refreshCells({ force: true });
        }
    }, [hasUnsavedChanges, editableRowId, gridApi, sourceGridApi]);

    const verifySimulation = debounce((e, type) => {
        if (!isEffectiveDateSelected) {
            Toaster.warning('Please select effective date')
            return false
        }

        // Check if there are unsaved changes before running simulation
        if (hasUnsavedChanges) {
            const currentRow = tableData?.find(row => (row?.OldRawMaterialId || row?.RawMaterialId || row?.NewRawMaterialId) === editableRowId);
            const rowName = getRowName(currentRow);
            Toaster.warning(`Please save changes in ${rowName} before running simulation`);
            return false;
        }

        // Check for zero or negative net costs before running simulation
        const invalidNetCostItem = tableData?.find(item => {
            // Use ?? (nullish coalescing) to properly handle 0 values
            // If NewNetLandedCost exists (even if 0), use it; otherwise use OldNetLandedCost
            const netCost = item?.NewNetLandedCost ?? item?.OldNetLandedCost;
            const finalNetCost = checkForNull(netCost);
            return finalNetCost <= 0;
        });

        if (invalidNetCostItem) {
            const rowName = getRowName(invalidNetCostItem);
            Toaster.warning(`Cannot run simulation when ${rowName} has zero or negative net cost. Please adjust the costs first.`);
            return false;
        }
        dispatch(setEffectiveDateRMNonIndexation(null));
        if (type !== 'verify') {
            setIsLoader(true)
            setIsDisable(true)
            let obj = {
                LoggedInUserId: loggedInUserId(),
                SimulationId: simulationId,
                IsProvisional: false,
                EffectiveDate: selectedEffectiveDate && DayTime(selectedEffectiveDate).isValid() ? DayTime(selectedEffectiveDate).format('YYYY-MM-DD HH:mm:ss') : null
            }
            dispatch(runSimulationOnRawMaterial(obj, (res) => {
                if (res?.data?.Result) {

                    setIsDisable(false)
                    let obj1 = {
                        LoggedInUserId: loggedInUserId(),
                        SimulationId: simulationId
                    }

                    dispatch(editRMIndexedSimulationData(obj1, (res) => {
                        let Data = res?.data?.Data.SimulationRawMaterialDetailsResponse
                        let shouldDisable = false;
                        let approvalMessage = '';

                        for (const item of Data) {
                            if (item.IsLockedBySimulation) {
                                shouldDisable = true;
                            }
                            if (item.ApprovalLockedMessage) {
                                approvalMessage = item.ApprovalLockedMessage;
                            }
                        }
                        
                        // CRITICAL FIX: Update effective date in Redux store
                        const newEffectiveDate = res?.data?.Data?.EffectiveDate;
                        if (newEffectiveDate) {
                            dispatch(setEffectiveDateRMNonIndexation(newEffectiveDate));
                            setEffectiveDate(newEffectiveDate);
                        }
                        
                        setDisableSendForApproval(shouldDisable);
                        setSendForApprovalMessage(approvalMessage);
                        setRunSimulationClicked(true)
                        setIsViewFlag(true)
                        setTokenNumber(res?.data?.Data?.TokenNumber)
                        setSimulationTechnologyIdState(res?.data?.Data?.SimulationTechnologyId)
                        setSimulationHeadId(res?.data?.Data?.SimulationHeadId)
                        setIsLoader(false)

                    }))
                } else {
                    setIsDisable(false)
                }
            }))
        } else {
            if (!isEffectiveDateSelected) {
                setIsWarningMessageShow(true)
                setIsDisable(true)
                return false
            }
            let obj = {}
            obj.Technology = technology
            obj.SimulationTechnologyId = selectedMasterForSimulation.value
            obj.SimulationHeadId = list[0]?.CostingHeadId
            obj.Masters = master
            obj.LoggedInUserId = loggedInUserId()

            obj.TechnologyId = technologyId
            obj.EffectiveDate = effectiveDate && DayTime(effectiveDate).isValid() ? DayTime(effectiveDate).format('YYYY-MM-DD HH:mm:ss') : null
            if (filteredRMData.plantId && filteredRMData.plantId.value) {
                obj.PlantId = filteredRMData.plantId ? filteredRMData.plantId.value : ''
            }
            let tempArr = []

            list && list.map(item => {
                let tempObj = {}
                tempObj.RawMaterialId = item.OldRawMaterialIndexationDetails.RawMaterialId
                tempObj.NewRawMaterialId = item.NewRawMaterialIndexationDetails.RawMaterialId
                tempObj.CostingHead = item.CostingHead
                tempObj.RawMaterialName = item.RawMaterialName
                tempObj.MaterialType = item.MaterialType
                tempObj.RawMaterialGrade = item.RawMaterialGrade
                tempObj.RawMaterialSpecification = item.RawMaterialSpecs
                tempObj.RawMaterialCategory = item.Category
                tempObj.UOM = item.UOM
                tempObj.OldBasicRate = item.OldRawMaterialIndexationDetails.BasicRate
                tempObj.NewBasicRate = item.NewRawMaterialIndexationDetails.BasicRate
                tempObj.OldScrapRate = item.OldRawMaterialIndexationDetails.ScrapRate
                tempObj.NewScrapRate = item.NewRawMaterialIndexationDetails.ScrapRate
                tempObj.RawMaterialFreightCost = checkForNull(item.RMFreightCost)
                tempObj.RawMaterialShearingCost = checkForNull(item.RMShearingCost)
                tempObj.OldNetLandedCost = item.OldRawMaterialIndexationDetails.NetLandedCost
                tempObj.NewNetLandedCost = item.NewRawMaterialIndexationDetails.NetLandedCost
                tempObj.EffectiveDate = item.NewRawMaterialIndexationDetails.EffectiveDate
                tempObj.PlantId = item.PlantId
                tempObj.VendorId = item.VendorId
                tempObj.Delta = 0
                tempObj.OldScrapRatePerScrapUOM = 0
                tempObj.NewScrapRatePerScrapUOM = 0
                tempArr.push(tempObj)

                return null;
            })

            obj.SimulationIds = tokenForMultiSimulation
            obj.SimulationRawMaterials = tempArr
            obj.SimulationExchangeRates = []
            obj.IsExchangeRateSimulation = false
            obj.IsSimulationWithOutCosting = false

            dispatch(runVerifySimulation(obj, res => {
                setIsDisable(false)

                if (res?.data?.Result) {
                    setToken(res?.data?.Identity)
                    setShowVerifyPage(true)
                }
            }))
        }



    }, 600)

    const setCommodityDetailsData = (commoditiDetails) => {
        setCommodityDetailForRow(commoditiDetails)
        const updatedCommodityDetails = commoditiDetails.map(detail => {

            return {
                ...detail,
                ExchangeRate: detail ? detail.ExchangeRate : null,
                TotalCostPercent: preciseDivide(preciseMultiply(checkForNull(detail?.TotalCostConversion), checkForNull(detail?.Percentage)), 100),
            };
        });
        setCommodityDetailForRow(commoditiDetails)
        dispatch(setCommodityDetails(updatedCommodityDetails))
    }

    const cancelVerifyPage = () => {
        setShowVerifyPage(false)
    }
    const resetState = () => {
        gridApi?.setQuickFilter('');
        setTextFilterSearch('')
        gridOptions?.columnApi?.resetColumnState();
        gridOptions?.api?.setFilterModel(null);
        window.screen.width >= 1921 && gridRef.current.api.sizeColumnsToFit();
    }

    /**
     * @method shearingCostFormatter
     * @description Renders buttons
     */
    const CostFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;

        return cell != null ? cell : '-';
    }

    const onFloatingFilterChanged = (value) => {
        setTimeout(() => {
            if (list.length !== 0) {
                setNoData(searchNocontentFilter(value, noData))
            }
        }, 500);
    }
    const effectiveDateFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        return cell != null ? <span title={DayTime(cell).format('DD/MM/YYYY')}> {cell.includes("T") ? DayTime(cell).format('DD/MM/YYYY') : cell}</span> : '';
    }


    const costingHeadFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        return cell ? cell : '-';
    }

    const vendorFormatter = (props) => {
        return (<span title={isbulkUpload || isCostingSimulation ? props?.value : props?.data.VendorName}>{isbulkUpload || isCostingSimulation ? props?.value : props?.data.VendorName}</span>);
    }

    const customerFormatter = (props) => {
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        return (<span title={isbulkUpload ? row['Customer (Code)'] : row.CustomerName}>{isbulkUpload ? row['Customer (Code)'] : row.CustomerName}</span>);
    }

    const plantFormatter = (props) => {
        return (<span title={isbulkUpload || isCostingSimulation ? props?.value : props?.data.DestinationPlantName}>{isbulkUpload || isCostingSimulation ? props?.value : props?.data.DestinationPlantName}</span>);
    }
    const newBasicRateFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        let PercentageCalc = 0
        if (row.Percentage) {
            PercentageCalc = preciseAdd(row?.BasicRatePerUOM, preciseDivide(preciseMultiply(Number(row?.BasicRatePerUOM), Number(row?.Percentage)), 100))
            if (isNaN(PercentageCalc)) {
                PercentageCalc = row?.BasicRatePerUOM
            }
        }
        return (
            <>
                {
                    isImpactedMaster ?
                        <PriceComparisonSpan
                            newValue={row?.NewBasicRatePerUOM}
                            oldValue={row?.OldBasicRatePerUOM}
                            costingTypeId={row?.CostingTypeId}
                            className="form-control with-button"
                            title={checkForDecimalAndNull(row.NewBasicRate, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)}
                        >
                            {checkForDecimalAndNull(row.NewBasicRate, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)}
                        </PriceComparisonSpan> :
                        <PriceComparisonSpan
                            newValue={row?.NewBasicRatePerUOM}
                            oldValue={row?.OldBasicRatePerUOM}
                            costingTypeId={row?.CostingTypeId}
                            id={`newBasicRate-${props.rowIndex}`}
                            className="form-control with-button"
                            title={cell ? Number(cell) : Number(row.BasicRatePerUOM)}
                        >
                            {cell ? Number(cell) : row.Percentage ? PercentageCalc : isbulkUpload ? checkForDecimalAndNull(cell, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6) : checkForDecimalAndNull(row.BasicRatePerUOM, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)}
                        </PriceComparisonSpan>
                }
                {!isCostingSimulation && <button
                    type="button"
                    className={`${(isRunSimulationClicked || isApprovalSummary || row?.IsSourceVendor === true) ? 'View small' : ' add-out-sourcing'} ml-1`}
                    onClick={() => CommodityDetailDrawer(cell, row, props.rowIndex, 'New')}
                    title="Add"
                >
                </button>}

            </>
        )
    }

    const newBasicRateFormatterForNonIndexedRM = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;

        let PercentageCalc = 0
        if (row.Percentage) {
            PercentageCalc = preciseAdd(row?.OldBasicRatePerUOM, preciseDivide(preciseMultiply(Number(row?.OldBasicRatePerUOM), Number(row?.Percentage)), 100))
            if (isNaN(PercentageCalc)) {
                PercentageCalc = row?.OldBasicRatePerUOM
            }
        }

        const displayValue = cell ? Number(cell) : row.Percentage ? PercentageCalc : isbulkUpload ? checkForNull(cell) : checkForNull(row.OldBasicRatePerUOM);

        const newBasicRate = Number(row?.NewBasicRatePerUOM || 0);
        const oldBasicRate = Number(row?.OldBasicRatePerUOM || 0);

        return (
            <>
                {
                    isImpactedMaster ?
                        <PriceComparisonSpan
                            newValue={newBasicRate}
                            oldValue={oldBasicRate}
                            costingTypeId={row?.CostingTypeId}
                            className={`form-control ${row?.Percentage && Number(row?.Percentage) !== 0 && !row?.NewBasicRatePerUOM ? 'disabled' : ''} basicRate_revised`}
                            title={checkForDecimalAndNull(row.NewBasicRatePerUOM, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)}
                        >
                            {checkForDecimalAndNull(row.NewBasicRatePerUOM, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)}
                        </PriceComparisonSpan> :
                        <PriceComparisonSpan
                            newValue={newBasicRate}
                            oldValue={oldBasicRate}
                            costingTypeId={row?.CostingTypeId}
                            id={`NewBasicRatePerUOM-${props.rowIndex}`}
                            className={`${!isbulkUpload && !isImpactedMaster && !isRunSimulationClicked && !isApprovalSummary ? 'form-control' : ''} ${row?.Percentage && Number(row?.Percentage) !== 0 && !row?.NewBasicRatePerUOM ? 'disabled' : ''} basicRate_revised`}
                            title={cell ? Number(cell) : Number(row.OldBasicRatePerUOM)}
                        >
                            {displayValue}
                        </PriceComparisonSpan>
                }

            </>
        )
    }
    const CommodityDetailDrawer = (value, row, index, type) => {
        setRowData(row)

        if (type === 'Old') {

            setCommodityDetailsData(row?.OldMaterialCommodityIndexRateDetails)
            setOtherCostDetailForRow(row?.OldRawMaterialOtherCostDetails)

            setIsViewFlag(true)

            setEditIndex(index)
        } else {
            setCommodityDetailsData(row?.NewMaterialCommodityIndexRateDetails)
            setOtherCostDetailForRow(row?.NewRawMaterialOtherCostDetails)

            setIsViewFlag((row?.IsSourceVendor === true || isRunSimulationClicked || isApprovalSummary) ? true : false)
            setEditIndex(index)
        }

        setOpenCommodityDrawer(true)

    }
    const closeCommodityDrawer = (type, basicRate = '') => {
        if (type === 'Save') {
            // Update local data first to trigger change tracking
            const currentRowId = editableRowId;
            const result = updateRowDataById(currentRowId, {
                NewBasicRatePerUOM: Number(basicRate)
            });

            setTotalBasicRate(basicRate)
            setIsSaving(true)

            // Trigger change detection
            if (result && result.updatedRow) {
                onValueChange({ data: result.updatedRow, node: { rowIndex: result.index } });
            }

            calculateAndSave(basicRate, [], 0, '', editIndex);
        }
        setOpenCommodityDrawer(false)
        setOtherCostDetailForRow([])
        setConditionCostDetailForRow([])
        setCommodityDetailForRow([])
    }
    const otherCostDrawer = (value, row, index, type) => {
        // Check for unsaved changes before opening drawer for different row
        if (hasUnsavedChanges && editableRowId && editableRowId !== row?.OldRawMaterialId) {
            const currentRow = tableData?.find(r => (r?.OldRawMaterialId || r?.RawMaterialId || r?.NewRawMaterialId) === editableRowId);
            const rowName = getRowName(currentRow);
            const targetRowName = getRowName(row);
            Toaster.warning(`Please save changes in ${rowName} before opening ${targetRowName} other cost`);
            return;
        }

        // For editing new values, use beginEdit to ensure proper row switching validation
        if (type === 'New') {
            if (!beginEdit({ data: row, node: { rowIndex: index } })) {
                return;
            }
        }

        // Always work with latest store row by ID
        const currentRowId = row?.OldRawMaterialId;
        const latestRow = findRowDataById(currentRowId) || row;

        setIsSourceVendorDrawer(latestRow?.IsSourceVendor === true);
        setRowData(latestRow);

        if (type === 'Old') {
            const basicRate = checkForNull(latestRow?.OldBasicRatePerUOM);
            setCommodityDetailsData(latestRow?.OldMaterialCommodityIndexRateDetails);
            setTotalBasicRate(basicRate);
            setNetCostWithoutConditionCost(latestRow?.OldNetCostWithoutConditionCost);
            setOtherCostDetailForRow(latestRow?.OldRawMaterialOtherCostDetails);
            setIsViewFlag(true);
            setEditIndex(index);
            setRowIndex(index);
        } else {
            const basicRate = checkForNull(latestRow?.NewBasicRatePerUOM);
            setCommodityDetailsData(latestRow?.NewMaterialCommodityIndexRateDetails);
            setIsSaving(true);
            setTotalBasicRate(basicRate);
            setNetCostWithoutConditionCost(latestRow?.NewNetCostWithoutConditionCost);
            setOtherCostDetailForRow(latestRow?.NewRawMaterialOtherCostDetails);
            setIsViewFlag((isRunSimulationClicked || isApprovalSummary) ? true : false);
            setEditIndex(index);
            setRowIndex(index);
        }

        setOpenOtherCostDrawer(true);
    };
    const conditionCostDrawer = (value, row, index, type) => {
        // Block drawer opening for source vendor rows when type is 'New'
        if (type === 'New' && row?.IsSourceVendor === true) {
            const rowName = getRowName(row);
            Toaster.warning(`Cannot edit condition costs for source vendor record (${rowName}) as it is read-only`);
            return;
        }

        // Check for unsaved changes before opening drawer for different row
        if (hasUnsavedChanges && editableRowId && editableRowId !== row?.OldRawMaterialId) {
            const currentRow = tableData?.find(r => (r?.OldRawMaterialId || r?.RawMaterialId || r?.NewRawMaterialId) === editableRowId);
            const rowName = getRowName(currentRow);
            const targetRowName = getRowName(row);
            Toaster.warning(`Please save changes in ${rowName} before opening ${targetRowName} condition cost`);
            return;
        }

        // For editing new values, use beginEdit to ensure proper row switching validation
        if (type === 'New') {
            if (!beginEdit({ data: row, node: { rowIndex: index } })) {
                return;
            }
        }

        // Always work with latest store row by ID
        const currentRowId = row?.OldRawMaterialId;
        const latestRow = findRowDataById(currentRowId) || row;

        setRowData(latestRow);

        if (type === 'Old') {
            const basicRate = checkForNull(latestRow?.OldBasicRatePerUOM);
            setCommodityDetailsData(latestRow?.OldMaterialCommodityIndexRateDetails);
            setTotalBasicRate(basicRate);
            setNetCostWithoutConditionCost(latestRow?.OldNetCostWithoutConditionCost);
            setConditionCostDetailForRow(latestRow?.OldRawMaterialConditionsDetails || []);
            setIsViewFlag(true);
            setEditIndex(index);
            setRowIndex(index);
        } else {
            const basicRate = checkForNull(latestRow?.NewBasicRatePerUOM);
            setCommodityDetailsData(latestRow?.NewMaterialCommodityIndexRateDetails);
            setIsSaving(true);
            setTotalBasicRate(basicRate);
            setNetCostWithoutConditionCost(latestRow?.NewNetCostWithoutConditionCost);
            setConditionCostDetailForRow(isImpactedMaster ? latestRow?.SimulationRawMaterialConditionsDetails || [] : latestRow?.NewRawMaterialConditionsDetails || []);
            setIsViewFlag((isRunSimulationClicked || isApprovalSummary) ? true : false);
            setEditIndex(index);
            setRowIndex(index);
        }

        setOpenConditionCostDrawer(true);
    };
    const updateOtherCostLocal = (tableData, total, totalCostBase) => {
        const currentRowId = editableRowId;
        const current = findRowDataById(currentRowId);
        if (!current) return;

        const basicRate = checkForNull(current?.NewBasicRatePerUOM || current?.OldBasicRatePerUOM);
        const newNetCostWithoutConditionCost = basicRate + checkForNull(total);

        const result = updateRowDataById(currentRowId, {
            NewOtherNetCost: total,
            NewOtherNetCostConversion: totalCostBase,
            NewOtherNetCostLocalConversion: totalCostBase,
            NewRawMaterialOtherCostDetails: tableData,
            NewNetCostWithoutConditionCost: newNetCostWithoutConditionCost
        });

        setNetCostWithoutConditionCost(newNetCostWithoutConditionCost);
        setIsSaving(true);

        // Use the updated row returned from updateRowDataById
        if (result && result.updatedRow) {
            onValueChange({ data: result.updatedRow, node: { rowIndex: result.index } });
        }
    };
    const saveOtherCostToAPI = (tableData, total, totalCostBase) => {
        // Save to API when Save button is clicked
        setIsLoader(true)
        updateOtherCostLocal(tableData, total, totalCostBase);

        const row = findRowDataById(editableRowId);
        if (row) {
            calculateAndSave(row?.NewBasicRatePerUOM, tableData, total, 'Other Cost', editIndex, row);
        }
    }
    const updateConditionCostLocal = (tableData, totalCostBase) => {
        const currentRowId = editableRowId;
        const current = findRowDataById(currentRowId);
        if (!current) return;

        const result = updateRowDataById(currentRowId, {
            NewNetConditionCost: totalCostBase,
            NewConditionNetCostConversion: totalCostBase,
            NewConditionNetCostLocalConversion: totalCostBase,
            NewRawMaterialConditionsDetails: tableData
        });

        setIsSaving(true);

        // Use the updated row returned from updateRowDataById
        if (result && result.updatedRow) {
            onValueChange({ data: result.updatedRow, node: { rowIndex: result.index } });
        }
    };
    const calculateOtherCostAndSave = (tableData, total, totalCostBase) => {
        setIsLoader(true);

        updateOtherCostLocal(tableData, total, totalCostBase);

        const row = findRowDataById(editableRowId);
        if (!row) { setIsLoader(false); return; }

        calculateAndSave(row?.NewBasicRatePerUOM, tableData, total, 'Other Cost', editIndex, row);
    };

    const calculateAndSaveCondition = (tableData, totalCostBase) => {
        setIsLoader(true);

        updateConditionCostLocal(tableData, totalCostBase);

        const row = findRowDataById(editableRowId);
        if (!row) { setIsLoader(false); return; }

        calculateAndSave(row?.NewBasicRatePerUOM, tableData, totalCostBase, 'Condition Cost', editIndex, row);
    };
    const saveConditionCostToAPI = (tableData, totalCostBase) => {
        // Save to API when Save button is clicked
        setIsLoader(true)
        updateConditionCostLocal(tableData, totalCostBase);

        const row = findRowDataById(editableRowId);
        if (row) {
            calculateAndSave(row?.NewBasicRatePerUOM, tableData, totalCostBase, 'Condition Cost', editIndex, row);
        }
    }
    const closeOtherCostDrawer = (type, data, total, totalBase) => {
        if (type === 'Save') {
            setIsOtherCostSaving(true);
            // Only update local state, don't call API
            updateOtherCostLocal(data, total, totalBase);
        } else {
            setIsOtherCostSaving(false);
            if (data && data.length > 0) {
                updateOtherCostLocal(data, total, totalBase);
            }
        }
        setOpenOtherCostDrawer(false);
        setIsViewFlag(false);
        setOtherCostDetailForRow([]);
    };

    const closeConditionCostDrawer = (type, data) => {
        if (type === 'Save' || type === 'save') {
            setIsConditionCostSaving(true);
            const newConditionCost = data.reduce((acc, item) => preciseAdd(checkForNull(acc), checkForNull(item?.ConditionCostPerQuantity || 0)), 0);
            // Only update local state, don't call API
            updateConditionCostLocal(data, newConditionCost);
        } else {
            setIsConditionCostSaving(false);
            if (data && data.length > 0) {
                const newConditionCost = data.reduce((acc, item) => preciseAdd(checkForNull(acc), checkForNull(item?.ConditionCostPerQuantity || 0)), 0);
                updateConditionCostLocal(data, newConditionCost);
            }
        }
        setOpenConditionCostDrawer(false);
        setIsViewFlag(false);
        setConditionCostDetailForRow([]);
    };

    const calculateAndSave = (basicRate = 0, data = [], totalBase = 0, type = '', currentIndex = null, selectedRowData = null) => {
        const selectedRow = selectedRowData
            ? findRowDataById(selectedRowData?.OldRawMaterialId || selectedRowData?.RawMaterialId)
            : tableData?.[currentIndex];

        if (!selectedRow) return;

        const mergedRow = {
            ...selectedRow,
            ...selectedRowData,
            NewBasicRatePerUOM: selectedRowData?.NewBasicRatePerUOM ?? selectedRow?.NewBasicRatePerUOM,
            NewScrapRate: selectedRowData?.NewScrapRate ?? selectedRow?.NewScrapRate,
            NewFromDate: selectedRowData?.NewFromDate ?? selectedRow?.NewFromDate,
            NewToDate: selectedRowData?.NewToDate ?? selectedRow?.NewToDate,
            NewEffectiveDate: selectedRowData?.NewEffectiveDate ?? selectedRow?.NewEffectiveDate,
            NewOtherNetCost: selectedRow?.NewOtherNetCost,
            NewNetConditionCost: selectedRow?.NewNetConditionCost,
            NewNetCostWithoutConditionCost: selectedRow?.NewNetCostWithoutConditionCost,
            NewNetLandedCost: selectedRow?.NewNetLandedCost,
            NewRawMaterialOtherCostDetails: selectedRow?.NewRawMaterialOtherCostDetails,
            NewRawMaterialConditionsDetails: selectedRow?.NewRawMaterialConditionsDetails,
        };

        // Optional: date validation hook (if you already have one)
        // if (!validateDateFields(mergedRow)) { return; }

        setIsLoader(true);

        // Use selectedEffectiveDate if available (from DatePicker), otherwise use mergedRow.NewEffectiveDate
        const finalEffectiveDate = selectedEffectiveDate || mergedRow?.NewEffectiveDate || effectiveDate;

        const obj = {
            SimulationRawMaterialId: mergedRow?.NewRawMaterialId,
            RawMaterialId: mergedRow?.OldRawMaterialId,
            CutOffPrice: mergedRow?.NewCutOffPrice,
            IsCutOffApplicable: mergedRow?.NewIsCutOffApplicable,
            ScrapRate: Number(mergedRow?.NewScrapRate) || Number(mergedRow?.OldScrapRate),
            ScrapRateInINR: mergedRow?.ScrapRateInINR || '',
            CutOffPriceInINR: mergedRow?.CutOffPriceInINR || '',
            EffectiveDate: finalEffectiveDate && DayTime(finalEffectiveDate).isValid()
                ? DayTime(finalEffectiveDate).format('YYYY-MM-DD HH:mm:ss')
                : null,
            LoggedInUserId: loggedInUserId(),
            FromDate: mergedRow?.NewFromDate && DayTime(mergedRow.NewFromDate).isValid()
                ? DayTime(mergedRow.NewFromDate).format('YYYY-MM-DD HH:mm:ss')
                : null,
            ToDate: mergedRow?.NewToDate && DayTime(mergedRow.NewToDate).isValid()
                ? DayTime(mergedRow.NewToDate).format('YYYY-MM-DD HH:mm:ss')
                : null,
            Plant: mergedRow?.Plant,
            MaterialCommodityIndexRateDetails: commodityDetailsArray || [],
            IsScrapUOMApply: mergedRow?.IsScrapUOMApply,
            ScrapUnitOfMeasurementId: mergedRow?.ScrapUnitOfMeasurementId,
            ScrapUnitOfMeasurement: mergedRow?.ScrapUnitOfMeasurement,
            UOMToScrapUOMRatio: mergedRow?.UOMToScrapUOMRatio,
            CalculatedFactor: mergedRow?.CalculatedFactor,
            ScrapRatePerScrapUOM: mergedRow?.ScrapRatePerScrapUOM,
            ScrapRatePerScrapUOMConversion: mergedRow?.ScrapRatePerScrapUOMConversion,

            BasicRatePerUOM: (type === 'Other Cost' || type === 'Condition Cost')
                ? (mergedRow?.NewBasicRatePerUOM || mergedRow?.OldBasicRatePerUOM)
                : Number(basicRate),
            BasicRatePerUOMConversion: (type === 'Other Cost' || type === 'Condition Cost')
                ? (mergedRow?.NewBasicRatePerUOM || mergedRow?.OldBasicRatePerUOM)
                : Number(basicRate),

            OtherNetCost: type === 'Other Cost' ? totalBase : mergedRow?.NewOtherNetCost,
            OtherNetCostConversion: type === 'Other Cost' ? totalBase : mergedRow?.NewOtherNetCost,
            NetConditionCost: type === 'Condition Cost' ? totalBase : mergedRow?.NewNetConditionCost,
            NetConditionCostConversion: type === 'Condition Cost' ? totalBase : mergedRow?.NewNetConditionCost,

            RawMaterialOtherCostDetails: type === 'Other Cost' ? data : mergedRow?.NewRawMaterialOtherCostDetails,
            RawMaterialConditionsDetails: type === 'Condition Cost' ? data : mergedRow?.NewRawMaterialConditionsDetails,

            NetCostWithoutConditionCost: mergedRow?.NewNetCostWithoutConditionCost,
            NetCostWithoutConditionCostConversion: mergedRow?.NewNetCostWithoutConditionCost,
            NetLandedCost: mergedRow?.NewNetLandedCost,
            NetLandedCostConversion: mergedRow?.NewNetLandedCost,
            CommodityNetCost: mergedRow?.CommodityNetCost,
            CommodityNetCostConversion: mergedRow?.CommodityNetCost
        };

        dispatch(updateSimulationRawMaterial(obj, (response) => {
            if (response?.data?.Result) {
                dispatch(editRMIndexedSimulationData({ SimulationId: simulationId }, (res) => {
                    if (res?.data?.Result) {
                        dispatch({ type: GET_INDEXED_RM_FOR_SIMULATION, payload: res?.data?.Data?.SimulationRawMaterialDetailsResponse });
                        const rowName = mergedRow?.RawMaterialName || mergedRow?.RawMaterialCode || 'raw material';
                        Toaster.success(`${type ? `${type} for ` : ''}${rowName} saved successfully`);
                        saveSucceeded(mergedRow?.OldRawMaterialId);
                    } else {
                        Toaster.error('Failed to refresh data after save.');
                    }
                    setIsLoader(false);
                }));
            } else {
                setIsLoader(false);
                Toaster.error('Failed to save data. Please try again.');
            }
        }));
    };

    const oldBasicRateFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        return (
            <>
                {
                    isImpactedMaster ?
                        row.OldBasicRate :
                        <span title={cell ? Number(cell) : Number(row.BasicRatePerUOM)}>{cell ? Number(cell) : Number(row.BasicRatePerUOM)} </span>
                }
                {!isCostingSimulation && <button
                    type="button"
                    className={'View small'}
                    onClick={() => CommodityDetailDrawer(cell, row, props.rowIndex, 'Old')}
                    title="Add"
                >
                </button>}

            </>
        )
    }

    const newScrapRateFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : isCostingSimulation ? props.data.NewRawMaterialIndexationDetails : props?.data;

        const newScrapRate = Number(cell || row.NewScrapRate || 0);
        const oldScrapRate = Number(row.OldScrapRate || row.ScrapRate || 0);

        return (
            <>
                {
                    (isImpactedMaster || isRunSimulationClicked || isApprovalSummary || isCostingSimulation) ?
                        <PriceComparisonSpan
                            newValue={newScrapRate}
                            oldValue={oldScrapRate}
                            costingTypeId={row?.CostingTypeId}
                            className={`form-control ${row.IsScrapUOMApply === 'Yes' ? 'disabled' : ''}`}
                            title={checkForDecimalAndNull(isCostingSimulation ? row.ScrapRate : row.NewScrapRate, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)}
                        >
                            {checkForDecimalAndNull(isCostingSimulation ? row.ScrapRate : row.NewScrapRate, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)}
                        </PriceComparisonSpan> :
                        <PriceComparisonSpan
                            newValue={newScrapRate}
                            oldValue={oldScrapRate}
                            costingTypeId={row?.CostingTypeId}
                            id={`newScrapRate-${props.rowIndex}`}
                            className={`${!isbulkUpload ? 'form-control' : ''} ${row.IsScrapUOMApply === 'Yes' ? 'disabled' : ''}`}
                            title={cell ? Number(checkForNull(cell)) : Number(checkForNull(row.NewScrapRate))}
                        >
                            {cell ? Number(checkForNull(cell)) : Number(checkForNull(row.NewScrapRate))}
                        </PriceComparisonSpan>
                }
            </>
        )
    }
    const newScrapRateUOMFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const newScrapRateInOldUOM = checkForDecimalAndNull(cell * row?.CalculatedFactor, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)
        if (!isImpactedMaster) {
            row.NewScrapRate = newScrapRateInOldUOM
            row.NewScrapRatePerScrapUOM = cell
        }

        const newScrapRateUOM = Number(cell || 0);
        const oldScrapRateUOM = Number(row.ScrapRatePerScrapUOM || 0);

        return (
            <>
                {
                    isImpactedMaster ?
                        <PriceComparisonSpan
                            newValue={newScrapRateUOM}
                            oldValue={oldScrapRateUOM}
                            className={`form-control ${row.IsScrapUOMApply === 'No' ? 'disabled' : ''}`}
                            title={checkForDecimalAndNull(row.NewScrapRatePerScrapUOM, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)}
                        >
                            {checkForDecimalAndNull(row.NewScrapRatePerScrapUOM, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)}
                        </PriceComparisonSpan> :
                        <PriceComparisonSpan
                            newValue={newScrapRateUOM}
                            oldValue={oldScrapRateUOM}
                            id={`newScrapRate-${props.rowIndex}`}
                            className={`${!isbulkUpload ? 'form-control' : ''} ${row.IsScrapUOMApply === 'No' ? 'disabled' : ''}`}
                            title={cell ? Number(checkForNull(cell)) : Number(checkForNull(row.ScrapRatePerScrapUOM))}
                        >
                            {cell ? Number(cell) : Number(checkForNull(row.ScrapRatePerScrapUOM))}
                        </PriceComparisonSpan>
                }
            </>
        )
    }

    const oldScrapRateFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        return (
            <>
                {
                    isImpactedMaster ?
                        row.OldScrapRate :
                        <span title={cell ? Number(checkForNull(cell)) : Number(checkForNull(row.OldScrapRate))}>{cell ? Number(checkForNull(cell)) : Number(checkForNull(row.OldScrapRate))}</span>
                }
            </>
        )
    }

    const oldScrapRateFormatterPerScrapUOM = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        return (
            <>
                {
                    isImpactedMaster ?
                        row.OldScrapRatePerScrapUOM :
                        <span title={cell ? Number(checkForNull(cell)) : Number(checkForNull(row.ScrapRate))}>{cell ? Number(checkForNull(cell)) : Number(checkForNull(row.ScrapRate))}</span>
                }
            </>
        )
    }

    const costFormatter = (props) => {
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const value = isImpactedMaster ? row?.OldNetLandedCost : cell;

        // Handle zero values explicitly
        if (value === 0 || value === '0') {
            return '0';
        }

        return isImpactedMaster ? checkForDecimalAndNull(row?.OldNetLandedCost, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6) : checkForDecimalAndNull(cell, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)
    }

    /**
    * @method beforeSaveCell
    * @description CHECK FOR ENTER NUMBER IN CELL using common validation
    */
    const beforeSaveCell = (cell, props, type) => {
        return validateRevisedRate(cell, props, type);
    }

    const NewcostFormatter = (props) => {
        const row = props?.valueFormatted ? props.valueFormatted : isCostingSimulation ? props.data.NewRawMaterialIndexationDetails : props?.data;
        const rowValue = isCostingSimulation ? row.NetLandedCost : row?.NewNetLandedCost

        const newNetCost = Number(row?.NewNetLandedCost || 0);
        const oldNetCost = Number(row?.OldNetLandedCost || 0);

        // Handle zero values explicitly
        if (rowValue === 0 || rowValue === '0') {
            return (
                <PriceComparisonSpan
                    newValue={newNetCost}
                    oldValue={oldNetCost}
                    className="form-control with-button"
                    title="0"
                >
                    0
                </PriceComparisonSpan>
            );
        }

        return rowValue ? (
            <PriceComparisonSpan
                newValue={newNetCost}
                oldValue={oldNetCost}
                className="form-control with-button"
                title={checkForDecimalAndNull(rowValue, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)}
            >
                {checkForDecimalAndNull(rowValue, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)}
            </PriceComparisonSpan>
        ) : ''
    }
    const revisedBasicRateHeader = (props) => {
        return (
            <div className='ag-header-cell-label'>
                <span className='ag-header-cell-text '><span className={`${!isImpactedMaster ? 'mr-1' : ''}`}>Revised</span> {!isImpactedMaster && !isIndexedRM && <i className={`fa fa-info-circle tooltip_custom_right tooltip-icon mb-n3 ml-4 mt2 `} id={"basicRate-tooltip"}></i>} </span>
            </div>
        );
    };
    const revisedScrapRateHeader = (props) => {
        return (
            <div className='ag-header-cell-label'>
                <span className='ag-header-cell-text'><span className={`${!isImpactedMaster ? 'mr-1' : ''}`}>Revised</span> {!isImpactedMaster && !isIndexedRM && <i className={`fa fa-info-circle tooltip_custom_right tooltip-icon mb-n3 ml-4 mt2 `} id={"scrapRate-tooltip"}></i>} </span>
            </div>
        );
    };
    const cancel = () => {
        list && list.map((item) => {
            item.NewBasicRate = undefined
            item.NewScrapRate = undefined
            return null
        })
        props.backToSimulation()
        // setShowMainSimulation(true)                    //RE
    }

    const closeDrawer = (e = '') => {

        setShowRunSimulationDrawer(false)
    }


    const defaultColDef = {
        resizable: true,
        filter: true,
        sortable: false,
        editable: true
    };

    const onGridReady = (params) => {
        setGridApi(params.api)
        setGridColumnApi(params.columnApi)
        params.api.paginationGoToPage(0);
        setTimeout(() => {
            setShowTooltip(true)
        }, 100);
    };

    const onPageSizeChanged = (newPageSize) => {
        gridApi.paginationSetPageSize(Number(newPageSize));
    };

    const onFilterTextBoxChanged = (e) => {

        gridApi?.setQuickFilter(e?.target?.value);
        setTextFilterSearch(e?.target?.value)
    }
    const cellChange = (props) => {
        const rowData = props?.data;

        // Handle basic rate changes
        if (rowData && props.colDef && props.colDef.colId === 'NewBasicRatePerUOM') {
            const validation = validateAndFormatValue(rowData.NewBasicRatePerUOM, props, 'basicRate');
            if (!validation.isValid) {
                resetFieldToLastValidValue(rowData, 'basicRate', props, gridApi, indexedRMForSimulation, props.node.rowIndex);
                return;
            }

            // Recalculate net cost when basic rate changes
            if (rowData.NewBasicRatePerUOM && Number(rowData.NewBasicRatePerUOM) !== 0) {
                const manualBasicRate = Number(rowData.NewBasicRatePerUOM);

                // Calculate Net Cost Without Condition Cost
                rowData.NewNetCostWithoutConditionCost = manualBasicRate + checkForNull(rowData?.NewOtherNetCost || 0);

                // Calculate final Net Cost
                const conditionCost = checkForNull(rowData?.NewNetConditionCost || 0);
                const freightAndShearing = getConfigurationKey().IsShowFreightAndShearingCostFields ?
                    preciseAdd(checkForNull(rowData?.RMFreightCost || 0), checkForNull(rowData?.RMShearingCost || 0)) : 0;

                rowData.NewNetLandedCost = preciseAdd(rowData.NewNetCostWithoutConditionCost, conditionCost, freightAndShearing);

                // Update the indexedRMForSimulation array with explicit values
                if (indexedRMForSimulation && indexedRMForSimulation[props.node.rowIndex]) {
                    indexedRMForSimulation[props.node.rowIndex].NewBasicRatePerUOM = Number(rowData.NewBasicRatePerUOM);
                    indexedRMForSimulation[props.node.rowIndex].NewNetCostWithoutConditionCost = rowData.NewNetCostWithoutConditionCost;
                    indexedRMForSimulation[props.node.rowIndex].NewNetLandedCost = rowData.NewNetLandedCost;
                }

                // Update state to trigger re-render
                setTotalBasicRate(manualBasicRate);
                setNetCostWithoutConditionCost(rowData.NewNetCostWithoutConditionCost);
            }
        }

        // Handle scrap rate changes
        if (rowData && props.colDef && props.colDef.colId === 'NewScrapRate') {
            const validation = validateAndFormatValue(rowData.NewScrapRate, props, 'scrapRate');
            if (!validation.isValid) {
                resetFieldToLastValidValue(rowData, 'scrapRate', props, gridApi, indexedRMForSimulation, props.node.rowIndex);
                return;
            }

            // Update the indexedRMForSimulation array with new scrap rate
            if (indexedRMForSimulation && indexedRMForSimulation[props.node.rowIndex]) {
                indexedRMForSimulation[props.node.rowIndex].NewScrapRate = Number(rowData.NewScrapRate);
                if (rowData.IsScrapUOMApply === 'Yes' && rowData.CalculatedFactor) {
                    indexedRMForSimulation[props.node.rowIndex].NewScrapRatePerScrapUOM = preciseDivide(Number(rowData.NewScrapRate), rowData.CalculatedFactor);
                }

                // Dispatch Redux update to trigger change detection
                dispatch({
                    type: GET_INDEXED_RM_FOR_SIMULATION,
                    payload: [...indexedRMForSimulation]
                });
            }
        }

        // Handle scrap rate per scrap UOM changes
        if (rowData && props.colDef && props.colDef.colId === 'NewScrapRatePerScrapUOM') {
            const validation = validateAndFormatValue(rowData.NewScrapRatePerScrapUOM, props, 'scrapRate');
            if (!validation.isValid) {
                resetFieldToLastValidValue(rowData, 'scrapRate', props, gridApi, indexedRMForSimulation, props.node.rowIndex);
                return;
            }

            // Update the indexedRMForSimulation array with new scrap rate per scrap UOM
            if (indexedRMForSimulation && indexedRMForSimulation[props.node.rowIndex]) {
                indexedRMForSimulation[props.node.rowIndex].NewScrapRatePerScrapUOM = Number(rowData.NewScrapRatePerScrapUOM);
                if (rowData.CalculatedFactor) {
                    indexedRMForSimulation[props.node.rowIndex].NewScrapRate = preciseMultiply(Number(rowData.NewScrapRatePerScrapUOM), rowData.CalculatedFactor);
                }

                // Dispatch Redux update to trigger change detection
                dispatch({
                    type: GET_INDEXED_RM_FOR_SIMULATION,
                    payload: [...indexedRMForSimulation]
                });
            }
        }
    }

    const onCellValueChanged = (props) => {
        const rowData = props?.data

        if (rowData) {
            // Validate the changed value based on the column
            if (props.colDef?.colId === 'NewBasicRatePerUOM') {
                const validation = validateAndFormatValue(rowData.NewBasicRatePerUOM, props, 'basicRate');
                if (!validation.isValid) {
                    resetFieldToLastValidValue(rowData, 'basicRate', props, gridApi, indexedRMForSimulation, props.node.rowIndex);
                    return;
                }
            } else if (props.colDef?.colId === 'NewScrapRate') {
                const validation = validateAndFormatValue(rowData.NewScrapRate, props, 'scrapRate');
                if (!validation.isValid) {
                    resetFieldToLastValidValue(rowData, 'scrapRate', props, gridApi, indexedRMForSimulation, props.node.rowIndex);
                    return;
                }
            } else if (props.colDef?.colId === 'NewScrapRatePerScrapUOM') {
                const validation = validateAndFormatValue(rowData.NewScrapRatePerScrapUOM, props, 'scrapRate');
                if (!validation.isValid) {
                    resetFieldToLastValidValue(rowData, 'scrapRate', props, gridApi, indexedRMForSimulation, props.node.rowIndex);
                    return;
                }
            }

            setIsSaving(true)
            setTotalBasicRate(rowData?.NewBasicRatePerUOM)
            setNetCostWithoutConditionCost(rowData?.NewNetCostWithoutConditionCost)
            setIsOtherCostSaving(true)
            setIsConditionCostSaving(true)
        }

        // Call cellChange first to update data structures
        cellChange(props)

        // Then call the row change tracker to track changes (after data is updated)
        onValueChange(props);
    }

    const handleEffectiveDateChange = (date) => {

        setIsLoader(true)
        dispatch(setEffectiveDateRMNonIndexation(date));

        setEffectiveDate(date)
        setIsEffectiveDateSelected(true)
        setIsWarningMessageShow(false)
        setIsDisable(false)
        setTimeout(() => {
            setIsLoader(false)
        }, 100);
    }

    const EditableCallbackForNewScrapRate = (props) => {
        const rowData = props?.data;
        let value = false

        if (isRunSimulationClicked || isApprovalSummary || isCostingSimulation) {
            value = false
        } else if (rowData?.IsScrapUOMApply === 'No') {
            value = false
        } else {
            value = true
        }
        return value
    }
    // ID-based helpers to avoid index-based mutations
    const findRowDataById = (rawMaterialId) => {
        // Use tableData to handle all scenarios (list, indexedRMForSimulation, rmIndexedSimulationSummaryData)
        return tableData?.find(item => item?.OldRawMaterialId === rawMaterialId || item?.RawMaterialId === rawMaterialId);
    };

    const updateRowDataById = (rawMaterialId, updates) => {
        // Use tableData source to determine where to update
        const dataSource = isCostingSimulation ? list : isApprovalSummary ? rmIndexedSimulationSummaryData : indexedRMForSimulation;

        const index = dataSource?.findIndex(item => item?.OldRawMaterialId === rawMaterialId || item?.RawMaterialId === rawMaterialId);
        if (index >= 0 && dataSource) {
            const updatedArray = [...dataSource];
            updatedArray[index] = {
                ...updatedArray[index],
                ...updates
            };

            // Only dispatch if we're updating indexedRMForSimulation (not for list or rmIndexedSimulationSummaryData)
            if (!isCostingSimulation && !isApprovalSummary) {
                dispatch({
                    type: GET_INDEXED_RM_FOR_SIMULATION,
                    payload: updatedArray
                });
            }

            // Return the updated row and its index
            return { updatedRow: updatedArray[index], index };
        }
        return null;
    };
    const EditableCallbackForNewScrapRateSecond = (props) => {
        const rowData = props?.data;
        let value = false

        if (isRunSimulationClicked || isApprovalSummary || isCostingSimulation) {
            value = false
        } else if (rowData?.IsScrapUOMApply === 'Yes') {
            value = false
        } else {
            value = true
        }
        return value
    }

    const ageValueGetterPer = (params) => {
        let row = params.data
        if (!row.Percentage) {
            if (row.NewBasicRate) {
                return 0
            }
            return row?.BasicRatePerUOM * 0;
        } else {
            return row?.Percentage
        }
    };

    const percentageFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        let cellValue = cell
        if (cell && cell > 100) {
            const rowName = getRowName(props?.data);
            Toaster.warning(`Percentage for ${rowName} should be less than or equal to 100`)
            list[props.rowIndex].Percentage = 0
            cellValue = 0
        }
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        return (
            <>
                {
                    <span id={`percentage${props.rowIndex}`} className={`${!isbulkUpload ? 'form-control' : ''} ${row.NewBasicRate ? 'disabled' : ''}`} >{cell ? row.NewBasicRate ? 0 : Number(cellValue) : (row?.Percentage ? row?.Percentage : 0)} </span>
                }
            </>
        )
    }

    /**
     * @method hyphenFormatter
     */
    const hyphenFormatter = (props) => {
        const cellValue = props?.value;
        return cellValue ? cellValue : '-';
    }

    const changeList = (value) => {
        setIsLoader(true)
        list && list?.map(item => {
            item.Percentage = value;
            return null;
        })
        setTimeout(() => {
            setIsLoader(false)
        }, 100);
    }
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            changeList(e.target.value);
        }
    };

    const percentageHeader = () => {
        let value = '';
        const onHandler = (e) => {
            value = e.target.value
        }
        return (<div>
            <input type="text" className="form-control ag-grid-input" onChange={onHandler} onKeyPress={handleKeyPress} onBlur={() => changeList(value)} />
        </div>
        )
    }
    const existingOtherCostFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        return (
            <>
                {
                    isImpactedMaster ?
                        checkForDecimalAndNull(Number(row.BasicRatePerUOM), isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6) :
                        <span title={cell ? Number(cell) : Number(row.BasicRatePerUOM)}>{cell ? checkForDecimalAndNull(Number(cell), isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6) : checkForDecimalAndNull(Number(row.BasicRatePerUOM), isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)} </span>

                }
                {!isCostingSimulation && <button
                    type="button"
                    className={'View small'}
                    onClick={() => otherCostDrawer(cell, row, props.rowIndex, 'Old')}
                    title="Add"
                >
                </button>}

            </>
        )
    }
    const revisedOtherCostFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const showValue = cell ? checkForDecimalAndNull(Number(cell), isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6) : checkForDecimalAndNull(Number(row.BasicRatePerUOM), isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)

        const newOtherCost = Number(row?.NewOtherNetCost || 0);
        const oldOtherCost = Number(row?.OldOtherNetCost || 0);

        return (
            <div className="cell-with-button">
                {
                    isImpactedMaster ?
                        <PriceComparisonSpan
                            newValue={newOtherCost}
                            oldValue={oldOtherCost}
                            className="form-control with-button"
                            title={row.OldBasicRate}
                        >
                            {row.OldBasicRate}
                        </PriceComparisonSpan> :
                        <PriceComparisonSpan
                            newValue={newOtherCost}
                            oldValue={oldOtherCost}
                            className="form-control with-button"
                            title={showValue}
                        >
                            {showValue}
                        </PriceComparisonSpan>

                }
                {!isCostingSimulation && <button
                    type="button"
                    className={`${(isRunSimulationClicked || isApprovalSummary) ? 'View small ml-1' : ' add-out-sourcing ml-1'} `}
                    onClick={() => otherCostDrawer(cell, row, props.rowIndex, 'New')}
                    title="Add"
                >
                </button>}

            </div>
        )
    }
    const existingConditionCostFormatter = (props) => {

        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;

        // Show "-" for non-zero-based costing (vendor-based)
        if (row?.CostingTypeId !== ZBCTypeId) {
            return <span>-</span>;
        }

        return (
            <>
                {
                    isImpactedMaster ?
                        checkForDecimalAndNull(Number(row.BasicRatePerUOM), isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6) :
                        <span title={cell ? Number(cell) : Number(row.BasicRatePerUOM)}>{cell ? checkForDecimalAndNull(Number(cell), isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6) : checkForDecimalAndNull(Number(row.BasicRatePerUOM), isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)} </span>

                }
                {!isCostingSimulation && <button
                    type="button"
                    className={'View small'}
                    onClick={() => conditionCostDrawer(cell, row, props.rowIndex, 'Old')}
                    title="Add"
                >
                </button>}

            </>
        )
    }
    const revisedConditionCostFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;

        // Show "-" for non-zero-based costing (vendor-based)
        if (row?.CostingTypeId !== ZBCTypeId) {
            return <span>-</span>;
        }

        const showValue = cell ? checkForDecimalAndNull(Number(cell), isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6) : checkForDecimalAndNull(Number(row?.NetConditionCost), isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)

        const newConditionCost = Number(row?.NewNetConditionCost || 0);
        const oldConditionCost = Number(row?.OldNetConditionCost || 0);

        return (
            <>
                {
                    isImpactedMaster ?
                        <PriceComparisonSpan
                            newValue={newConditionCost}
                            oldValue={oldConditionCost}
                            className="form-control with-button"
                            title={row?.NewNetConditionCost}
                        >
                            {row?.NewNetConditionCost}
                        </PriceComparisonSpan> :
                        <PriceComparisonSpan
                            newValue={newConditionCost}
                            oldValue={oldConditionCost}
                            className="form-control with-button"
                            title={showValue}
                        >
                            {showValue}
                        </PriceComparisonSpan>

                }
                {/* {!isCostingSimulation && <button */}
                {true && <button
                    type="button"
                    // className={`${(isRunSimulationClicked || isApprovalSummary) ? 'View small ml-1' : ' add-out-sourcing ml-1'} `}
                    // onClick={() => ConditionCostDrawer(cell, row, props.rowIndex, 'New')}
                    className={`${(isImpactedMaster || isRunSimulationClicked || isApprovalSummary || row?.IsSourceVendor === true) ? 'View small ml-1' : ' add-out-sourcing ml-1'} `}
                    onClick={() => conditionCostDrawer(cell, row, props.rowIndex, 'New')}
                    title="Add"
                >
                </button>}

            </>
        )
    }


    const scrapEditableCallback = (props) => {
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        let isEditable = false
        if (isRunSimulationClicked || isApprovalSummary || isCostingSimulation) {
            isEditable = false
        } else {
            if (row?.IsScrapUOMApply === 'No') {
                isEditable = false
            } else {
                isEditable = true
            }
        }
        return isEditable
    }

    const actionCellRenderer = (props) => {
        const row = props?.data;
        const currentRowId = row?.OldRawMaterialId || row?.RawMaterialId || row?.NewRawMaterialId;

        // Check if there are unsaved changes in another row
        const hasUnsavedChangesInAnotherRow = hasUnsavedChanges && editableRowId && editableRowId !== currentRowId;

        const isDisabled = isRunSimulationClicked || isApprovalSummary || isImpactedMaster || hasUnsavedChangesInAnotherRow;

        return <div >
            <button
                title={hasUnsavedChangesInAnotherRow ? 'Please save changes in the highlighted row first' : 'Save'}
                className="SaveIcon"
                type={'button'}
                onClick={() => saveBasicRate(props)}
                disabled={isDisabled}
            />
            {/* <button title='Discard' className="CancelIcon" type={'button'} onClick={() => discardBasicRate(props)} /> */}
        </div>
    }
    const localConversionFormatter = (props) => {
        const cellValue = checkForNull(props?.value);
        return checkForDecimalAndNull(cellValue, isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)
    }
    const saveBasicRate = (props) => {
        const row = props?.valueFormatted ? props.valueFormatted : props?.data;
        const currentIndex = props.rowIndex; // Store index in local variable
        const currentRowId = row?.OldRawMaterialId || row?.RawMaterialId || row?.NewRawMaterialId;

        // Check if there are unsaved changes in another row
        if (hasUnsavedChanges && editableRowId && editableRowId !== currentRowId) {
            const editingRow = tableData?.find(r => (
                r?.OldRawMaterialId === editableRowId ||
                r?.RawMaterialId === editableRowId ||
                r?.NewRawMaterialId === editableRowId
            ));
            const editingRowName = getRowName(editingRow);
            const currentRowName = getRowName(row);

            Toaster.warning(`Please save changes in ${editingRowName} before saving ${currentRowName}`);
            return false;
        }

        // Check if current row is highlighted/has unsaved changes
        if (hasUnsavedChanges && editableRowId === currentRowId) {
            // This is the correct row to save - proceed
        } else if (!hasUnsavedChanges) {
            // No changes to save
            const currentRowName = getRowName(row);
            Toaster.info(`No changes to save in ${currentRowName}`);
            return false;
        }

        setIsLoader(true);
        if (!isIndexedRM && (selectedEffectiveDate === null || selectedEffectiveDate === undefined)) {
            Toaster.warning("Please select effective date")
            setIsLoader(false);
            return false
        }
        setEditIndex(currentIndex)

        setRowIndex(currentIndex)
        setRowData(row)

        setTotalBasicRate(checkForNull(row?.NewBasicRatePerUOM))
        setIsSaving(true)
        setNetCostWithoutConditionCost(row?.NewNetCostWithoutConditionCost)
        setIsSaving(true) // Add this line to trigger useEffect

        setTimeout(() => {
            // Call API with all updated data including Other Cost and Condition Cost
            calculateAndSave(row?.NewBasicRatePerUOM, [], 0, '', currentIndex, row);
        }, 1000);
    }

    const frameworkComponents = {
        effectiveDateFormatter: effectiveDateFormatter,
        costingHeadFormatter: costingHeadFormatter,
        CostFormatter: CostFormatter,
        newScrapRateFormatter: newScrapRateFormatter,
        newScrapRateUOMFormatter: newScrapRateUOMFormatter,
        NewcostFormatter: NewcostFormatter,
        costFormatter: costFormatter,
        customNoRowsOverlay: NoContentFound,
        newBasicRateFormatter: newBasicRateFormatter,
        cellChange: cellChange,
        oldBasicRateFormatter: oldBasicRateFormatter,
        oldScrapRateFormatter: oldScrapRateFormatter,
        vendorFormatter: vendorFormatter,
        customerFormatter: customerFormatter,
        plantFormatter: plantFormatter,
        revisedBasicRateHeader: revisedBasicRateHeader,
        revisedScrapRateHeader: revisedScrapRateHeader,
        ageValueGetterPer: ageValueGetterPer,
        percentageFormatter: percentageFormatter,
        percentageHeader: percentageHeader,
        // nullHandler: props.nullHandler && props.nullHandler,
        oldScrapRateFormatterPerScrapUOM: oldScrapRateFormatterPerScrapUOM,
        hyphenFormatter: hyphenFormatter,
        existingOtherCostFormatter: existingOtherCostFormatter,
        revisedOtherCostFormatter: revisedOtherCostFormatter,
        scrapEditableCallback: scrapEditableCallback,
        newBasicRateFormatterForNonIndexedRM: newBasicRateFormatterForNonIndexedRM,
        actionCellRenderer: actionCellRenderer,
        existingConditionCostFormatter: existingConditionCostFormatter,
        revisedConditionCostFormatter: revisedConditionCostFormatter,
        localConversionFormatter: localConversionFormatter
    };

    const ageValueGetterScrapRate = (params) => {
        let row = params.data
        let valueReturn = ''
        if (row.IsScrapUOMApply === 'Yes') {
            valueReturn = checkForDecimalAndNull(preciseMultiply(row.NewScrapRatePerScrapUOM, row.CalculatedFactor), isImpactedMaster ? getConfigurationKey().NoOfDecimalForPrice : 6)
        } else {
            valueReturn = row.NewScrapRate
        }
        return valueReturn
    }

    const basicRatetooltipToggle = () => {
        setBasicRateViewTooltip(!basicRateviewTooltip)
    }
    const scrapRatetooltipToggle = () => {
        setScrapRateViewTooltip(!scrapRateviewTooltip)
    }

    const onBtExport = () => {
        if (String(props?.masterId) === String(RMIMPORT)) {
            return returnExcelColumn(RM_IMPACT_DOWNLOAD_EXCEl_IMPORT, list)
        } else {

            return returnExcelColumn(RM_IMPACT_DOWNLOAD_EXCEl, list)
        }
    };

    const returnExcelColumn = (data = [], TempData) => {
        let temp = []
        TempData && TempData.map((item) => {
            item.EffectiveDate = (item.EffectiveDate)?.slice(0, 10)
            temp.push(item)
        })
        return (
            <ExcelSheet data={temp} name={'RM Data'}>
                {data && data.map((ele, index) => 
                    <ExcelColumn key={index} label={ele?.label} value={ele?.value} style={ele.style} />
                )}
            </ExcelSheet>
        );
    }

    const sendForApproval = () => {
        setIsApprovalDrawer(true)
    }
    const closeApprovalDrawer = (value, type) => {
        setIsApprovalDrawer(false)
        if (type === 'submit') {
            setShowApprovalHistory(true)
        }
    }

    const EditableCallbackForNewBasicRate = (props) => {
        const rowData = props?.data;

        let value = false

        // Block editing for source vendor rows
        if (rowData?.IsSourceVendor === true) {
            value = false
        } else if (!rowData?.OldBasicRatePerUOM) {
            value = false
        } else {
            value = true
        }
        setRowIndex(props?.node?.rowIndex)
        return value
    }

    // Use the comprehensive valueSetter from helper
    const valueSetterWithValidation = (params, type) => {
        // Call the helper function which has comprehensive validation
        return valueSetterFromHelper(params, type);
    };
    /**
    * @method validateRowEdit
    * @description Validate if the current row can be edited
    */
    const validateRowEdit = (params) => {
        return beginEdit(params);
    }
    // Create unique refs for different grid instances
    const sourceGridRef = useRef();

    /**
     * @method renderRMTable
     * @description Reusable function to render Raw Material tables for both source and non-source vendors
     * @param {Array} rowData - Data to display in the table
     * @param {boolean} showActionColumn - Whether to show action column
     * @param {boolean} showRowNumber - Whether to show row number column
     * @param {Object} paginationProps - Pagination configuration
     * @returns {JSX.Element} Rendered table component
     */
    const renderRMTable = (rowData, showActionColumn = true, showRowNumber = false, paginationProps = null) => {
        // Use appropriate grid ref based on grid type
        const gridRefToUse = paginationProps?.isSourceGrid ? sourceGridRef : gridRef;

        return (
            <div>
                <div>
                    <AgGridReact
                        ref={gridRefToUse}
                        floatingFilter={true}
                        style={{ height: '100%', width: '100%' }}
                        defaultColDef={defaultColDef}
                        domLayout='autoHeight'
                        rowData={isApprovalSummary ? simulationData : rowData}
                        suppressPagination={true}
                        onGridReady={(params) => {
                            if (paginationProps?.isSourceGrid) {
                                setSourceGridApi(params.api);
                            } else {
                                setGridApi(params.api);
                                setGridColumnApi(params.columnApi);
                            }
                            // Set row data after API is ready
                            setTimeout(() => {
                                params.api.setRowData(isApprovalSummary ? simulationData : rowData);
                            }, 0);
                        }}
                        gridOptions={gridOptions}
                        loadingOverlayComponent={'customLoadingOverlay'}
                        noRowsOverlayComponent={'customNoRowsOverlay'}
                        noRowsOverlayComponentParams={{
                            title: EMPTY_DATA,
                        }}
                        frameworkComponents={frameworkComponents}
                        suppressColumnVirtualisation={true}
                        stopEditingWhenCellsLoseFocus={true}
                        onCellEditingStarted={(params) => { if (!validateRowEdit(params)) { params.api.stopEditing(true); } }}
                        getRowStyle={rowStyle}
                        onCellValueChanged={onCellValueChanged}
                        onFilterModified={onFloatingFilterChanged}
                        enableBrowserTooltips={true}
                        immutableData={true}
                        getRowNodeId={(data) => data.OldRawMaterialId || data.RawMaterialId}
                    >
                        {showRowNumber && (
                            <AgGridColumn headerName="Row No." headerTooltip="Row No." width={60} valueGetter={(params) => params.node.rowIndex + 1} suppressMovable={true} sortable={false} filter={false} />
                        )}

                        {!isImpactedMaster &&
                            <AgGridColumn minWidth={columnWidths?.CostingHead} field="CostingHead" tooltipField='CostingHead' headerName="Costing Head" editable='false' cellRenderer={'costingHeadFormatter'}></AgGridColumn>
                        }

                        <AgGridColumn field="EntryType" minWidth={120} headerName="Entry Type" cellRenderer={"hyphenFormatter"} editable='false'></AgGridColumn>
                        <AgGridColumn minWidth={columnWidths?.RawMaterialName} field="RawMaterialName" tooltipField='RawMaterialName' editable='false' headerName="Raw Material"></AgGridColumn>
                        <AgGridColumn minWidth={columnWidths?.RawMaterialGradeName} field={props.isCostingSimulation ? 'RawMaterialGrade' : "RawMaterialGradeName"} tooltipField='RawMaterialGradeName' editable='false' headerName="Grade" ></AgGridColumn>
                        <AgGridColumn minWidth={columnWidths?.RawMaterialSpecificationName} field={props.isCostingSimulation ? 'RawMaterialSpecs' : "RawMaterialSpecificationName"} tooltipField='RawMaterialSpecificationName' editable='false' headerName="Specification"></AgGridColumn>
                        <AgGridColumn minWidth={columnWidths?.RawMaterialCode} field="RawMaterialCode" tooltipField='RawMaterialCode' editable='false' headerName='Code' cellRenderer='hyphenFormatter'></AgGridColumn>

                        {getConfigurationKey()?.IsShowSourceVendorInRawMaterial && !props.isCostingSimulation &&
                            <AgGridColumn field="SourceVendorAssociatedAsRawMaterialVendors" minWidth={250} headerName={`Raw Material Code (Source ${vendorLabel} Code)`} cellRendererFramework={CustomCellRenderer}></AgGridColumn>
                        }

                        {getConfigurationKey()?.IsShowSourceVendorInRawMaterial &&
                            <AgGridColumn minWidth={columnWidths?.SourceVendorName} field="SourceVendorName" tooltipField='SourceVendorName' editable='false' headerName={`Source ${vendorLabel} (Code)`} cellRenderer='hyphenFormatter'></AgGridColumn>
                        }

                        {!isImpactedMaster &&
                            <AgGridColumn minWidth={columnWidths?.RawMaterialCategoryName} field={props.isCostingSimulation ? 'Category' : "RawMaterialCategoryName"} tooltipField='RawMaterialCategoryName' editable='false' headerName="Category"></AgGridColumn>
                        }

                        {!isImpactedMaster &&
                            <AgGridColumn minWidth={columnWidths?.TechnologyName} field={props.isCostingSimulation ? 'Technology' : "TechnologyName"} tooltipField='TechnologyName' editable='false' headerName={technologyLabel} ></AgGridColumn>
                        }

                        {!isImpactedMaster && list && list[0]?.CostingTypeId !== CBCTypeId &&
                            <AgGridColumn minWidth={columnWidths?.VendorCode} field={props.isCostingSimulation ? 'VendorCode' : "Vendor (Code)"} tooltipField='Vendor (Code)' editable='false' headerName={vendorLabel + " (Code)"} cellRenderer='vendorFormatter'></AgGridColumn>
                        }

                        {!isImpactedMaster && list && list[0]?.CostingTypeId === CBCTypeId &&
                            <AgGridColumn minWidth={columnWidths?.CustomerName} field={props.isCostingSimulation ? 'CustomerCode' : "CustomerName"} tooltipField='CustomerName' editable='false' headerName="Customer (Code)" cellRenderer='customerFormatter'></AgGridColumn>
                        }

                        {!isImpactedMaster &&
                            <AgGridColumn minWidth={columnWidths?.PlantCode} field={props.isCostingSimulation ? 'PlantCode' : "Plant (Code)"} editable='false' headerName="Plant (Code)" tooltipField='Plant (Code)' cellRenderer='plantFormatter' ></AgGridColumn>
                        }

                        <AgGridColumn minWidth={columnWidths?.UnitOfMeasurementName} field={props.isCostingSimulation ? 'UOM' : "UnitOfMeasurementName"} tooltipField='UnitOfMeasurementName' editable='false' headerName="UOM"></AgGridColumn>

                        {isScrapUOMApplyTemp &&
                            <AgGridColumn minWidth={150} field="ScrapUnitOfMeasurement" tooltipField='ScrapUnitOfMeasurement' editable='false' headerName="Scrap UOM" cellRenderer='hyphenFormatter'></AgGridColumn>
                        }

                        {costingAndPartNo &&
                            <AgGridColumn field="CostingNumber" tooltipField='CostingNumber' editable='false' headerName="Costing No" minWidth={columnWidths?.CostingNumber}></AgGridColumn>
                        }

                        {costingAndPartNo &&
                            <AgGridColumn field="PartNumber" tooltipField='PartNumber' editable='false' headerName="Part No" minWidth={columnWidths?.PartNumber}></AgGridColumn>
                        }

                        {String(props?.masterId) === String(RMIMPORT) && !isIndexedRM &&
                            <AgGridColumn field="Currency" tooltipField='Currency' editable='false' headerName="Currency" minWidth={140} ></AgGridColumn>
                        }

                        {(isImpactedMaster && String(props?.masterId) === String(RMIMPORT)) &&
                            <AgGridColumn field="ExchangeRate" tooltipField='ExchangeRate' editable='false' headerName="Existing Exchange Rate" minWidth={140} ></AgGridColumn>
                        }

                        {isIndexedRM && (
                            <>
                                <AgGridColumn field='IndexExchangeName' tooltipField='IndexExchangeName' editable='false' headerName="Index" minWidth={140} ></AgGridColumn>
                                <AgGridColumn field='ExchangeRateSourceName' tooltipField='ExchangeRateSourceName' editable='false' headerName="Exchange Rate Source" minWidth={140} ></AgGridColumn>
                                <AgGridColumn field='MaterialType' tooltipField='MaterialType' editable='false' headerName="Material" minWidth={140} ></AgGridColumn>
                                <AgGridColumn minWidth={columnWidths?.FrequencyOfSettlement} field={isCostingSimulation ? 'NewRawMaterialIndexationDetails.FrequencyOfSettlement' : "FrequencyOfSettlement"} editable='false' headerName={"Frequency Of Settlement"} ></AgGridColumn>
                                <AgGridColumn minWidth={columnWidths?.OldFromDate} field={isCostingSimulation ? 'OldRawMaterialIndexationDetails.FromDate' : "OldFromDate"} editable='false' cellRenderer={'effectiveDateFormatter'} headerName={props.isImpactedMaster && !props.lastRevision ? "Old Effective date" : "Old From Date"} ></AgGridColumn>
                                <AgGridColumn minWidth={columnWidths?.NewFromDate} field={isCostingSimulation ? 'NewRawMaterialIndexationDetails.FromDate' : "NewFromDate"} editable='false' cellRenderer={'effectiveDateFormatter'} headerName={props.isImpactedMaster && !props.lastRevision ? "New Effective date" : "New From Date"} ></AgGridColumn>
                                <AgGridColumn minWidth={columnWidths?.OldToDate} field={isCostingSimulation ? 'OldRawMaterialIndexationDetails.ToDate' : "OldToDate"} editable='false' cellRenderer={'effectiveDateFormatter'} headerName={props.isImpactedMaster && !props.lastRevision ? "Old Effective date" : "Old To Date"} ></AgGridColumn>
                                <AgGridColumn minWidth={columnWidths?.NewToDate} field={isCostingSimulation ? 'NewRawMaterialIndexationDetails.ToDate' : "NewToDate"} editable='false' cellRenderer={'effectiveDateFormatter'} headerName={props.isImpactedMaster && !props.lastRevision ? "New Effective date" : "New To Date"} ></AgGridColumn>
                            </>
                        )}

                        {getConfigurationKey().IsSourceExchangeRateNameVisible &&
                            <AgGridColumn minWidth={120} field="ExchangeRateSourceName" headerName="Exchange Rate Source" editable='false'></AgGridColumn>
                        }

                        <AgGridColumn field="Currency" minWidth={120} cellRenderer={"hyphenFormatter"}></AgGridColumn>

                        {(String(props?.masterId) === String(RMIMPORT) || String(props?.masterId) === String(EXCHNAGERATE)) &&
                            <AgGridColumn field="LocalCurrency" minWidth={120} headerName={"Plant Currency"} cellRenderer={"currencyFormatter"} editable='false' ></AgGridColumn>
                        }

                        {/* Basic Rate Column Group */}
                        <AgGridColumn headerClass="justify-content-center" cellClass="text-center" width={columnWidths?.BasicRate?.group} headerName={"Basic Rate (Currency)"} marryChildren={true} pinned='right' >
                            {!isIndexedRM &&
                                <AgGridColumn width={columnWidths?.BasicRate?.existing} field={isImpactedMaster ? "OldBasicRate" : isCostingSimulation ? 'OldRawMaterialIndexationDetails.BasicRate' : "OldBasicRatePerUOM"} editable='false' headerName="Existing" colId={isImpactedMaster ? "OldBasicRate" : "OldBasicRatePerUOM"} pinned='right'></AgGridColumn>
                            }
                            {isIndexedRM &&
                                <AgGridColumn width={columnWidths?.BasicRate?.existing} cellRenderer='oldBasicRateFormatter' field={isImpactedMaster ? "OldBasicRate" : isCostingSimulation ? 'OldRawMaterialIndexationDetails.BasicRate' : "OldBasicRatePerUOM"} editable='false' headerName="Existing" colId={isImpactedMaster ? "OldBasicRate" : "OldBasicRatePerUOM"} pinned='right'></AgGridColumn>
                            }
                            {!isIndexedRM &&
                                <AgGridColumn width={columnWidths?.BasicRate?.revised} cellRenderer='newBasicRateFormatterForNonIndexedRM' editable={(isImpactedMaster || isRunSimulationClicked || isApprovalSummary) ? false : EditableCallbackForNewBasicRate} onCellValueChanged='cellChange' field={isCostingSimulation ? 'NewRawMaterialIndexationDetails.BasicRate' : "NewBasicRatePerUOM"} headerName="Revised" colId='NewBasicRatePerUOM' headerComponent={'revisedBasicRateHeader'} valueSetter={(params) => valueSetterWithValidation(params, 'basicRate')} pinned='right'></AgGridColumn>
                            }
                            {isIndexedRM &&
                                <AgGridColumn width={columnWidths?.BasicRate?.revised} cellRenderer='newBasicRateFormatter' editable='false' field={isCostingSimulation ? 'NewRawMaterialIndexationDetails.BasicRate' : "NewBasicRatePerUOM"} headerName="Revised" colId='NewBasicRatePerUOM' pinned='right'></AgGridColumn>
                            }
                        </AgGridColumn>

                        {/* Scrap Rate Column Group */}
                        <AgGridColumn headerClass="justify-content-center" cellClass="text-center" width={columnWidths?.ScrapRate?.group} marryChildren={true} pinned='right' headerName={"Scrap Rate (Currency)"}>
                            {isScrapUOMApplyTemp &&
                                <AgGridColumn width={columnWidths?.ScrapRatePerScrapUOM} field={isImpactedMaster ? "OldScrapRatePerScrapUOM" : "ScrapRatePerScrapUOM"} editable='false' cellRenderer='oldScrapRateFormatterPerScrapUOM' headerName="Existing (In Scrap UOM)" colId={isImpactedMaster ? "ScrapRatePerScrapUOM" : "ScrapRatePerScrapUOM"} pinned='right'></AgGridColumn>
                            }
                            {isScrapUOMApplyTemp &&
                                <AgGridColumn width={columnWidths?.NewScrapRatePerScrapUOM} cellRenderer='newScrapRateUOMFormatter' field='NewScrapRatePerScrapUOM' headerName="Revised (In Scrap UOM)" colId={"NewScrapRatePerScrapUOM"} editable={(isRunSimulationClicked || isApprovalSummary) ? false : EditableCallbackForNewScrapRate} onCellValueChanged='cellChange' valueSetter={(params) => valueSetterWithValidation(params, 'scrapRate')} pinned='right'></AgGridColumn>
                            }
                            <AgGridColumn width={columnWidths?.ScrapRate.existing} field={isImpactedMaster ? "OldScrapRate" : isCostingSimulation ? 'OldRawMaterialIndexationDetails.ScrapRate' : "OldScrapRate"} editable='false' cellRenderer='oldScrapRateFormatter' headerName="Existing" colId={isImpactedMaster ? "OldScrapRate" : "OldScrapRate"} pinned='right'></AgGridColumn>
                            <AgGridColumn width={columnWidths?.ScrapRate.revised} cellRenderer={'newScrapRateFormatter'} field={isCostingSimulation ? 'NewRawMaterialIndexationDetails.ScrapRate' : "NewScrapRate"} headerName="Revised" colId="NewScrapRate" valueGetter={ageValueGetterScrapRate} headerComponent={'revisedScrapRateHeader'} editable={scrapEditableCallback} onCellValueChanged='cellChange' valueSetter={(params) => valueSetterWithValidation(params, 'scrapRate')} pinned='right'></AgGridColumn>
                        </AgGridColumn>

                        {/* Other Cost Column Group */}
                        <AgGridColumn headerClass="justify-content-center" cellClass="text-center" width={columnWidths?.OtherCost?.group} headerName={"Other Cost (Currency)"} marryChildren={true} pinned='right' >
                            <AgGridColumn width={columnWidths?.OtherCost.existing} cellRenderer='existingOtherCostFormatter' field={isImpactedMaster ? "OldOtherNetCost" : isCostingSimulation ? 'OldRawMaterialIndexationDetails.OtherNetCost' : "OldOtherNetCost"} editable='false' headerName="Existing" colId={isImpactedMaster ? "OldOtherNetCost" : "OldOtherNetCost"} pinned='right'></AgGridColumn>
                            <AgGridColumn width={columnWidths?.OtherCost.revised} cellRenderer='revisedOtherCostFormatter' editable={false} onCellValueChanged='cellChange' field={isCostingSimulation ? 'NewRawMaterialIndexationDetails.OtherNetCost' : "NewOtherNetCost"} headerName="Revised" colId='NewOtherNetCost' pinned='right'></AgGridColumn>
                        </AgGridColumn>

                        {/* Basic Price Column Group */}
                        {getConfigurationKey()?.IsBasicRateAndCostingConditionVisible && tableData?.some(item => item?.CostingTypeId === ZBCTypeId) &&
                            <AgGridColumn headerClass="justify-content-center" cellClass="text-center" width={columnWidths?.BasicPrice?.group} headerName={"Basic Price (Currency)"} marryChildren={true} pinned='right'>
                                <AgGridColumn width={columnWidths?.BasicPrice?.existing} field={isImpactedMaster ? 'OldNetCostWithoutConditionCost' : 'OldNetCostWithoutConditionCost'} editable='false' cellRenderer={'costFormatter'} headerName="Existing" colId='NetCostWithoutConditionCost' pinned='right'></AgGridColumn>
                                <AgGridColumn width={columnWidths?.BasicPrice?.revised} field={isImpactedMaster ? "NewNetCostWithoutConditionCost" : "NewNetCostWithoutConditionCost"} editable='false' cellRenderer={'costFormatter'} headerName="Revised" colId='NewNetCostWithoutConditionCost' pinned='right'></AgGridColumn>
                            </AgGridColumn>
                        }

                        {/* Condition Cost Column Group */}
                        {getConfigurationKey()?.IsBasicRateAndCostingConditionVisible && tableData?.some(item => item?.CostingTypeId === ZBCTypeId) &&
                            <AgGridColumn headerClass="justify-content-center" cellClass="text-center" width={columnWidths?.ConditionCost?.group} headerName={"Condition Cost (Currency)"} marryChildren={true} pinned='right' >
                                <AgGridColumn width={columnWidths?.ConditionCost.existing} cellRenderer='existingConditionCostFormatter' field={isImpactedMaster ? "OldNetConditionCost" : "OldNetConditionCost"} editable='false' headerName="Existing" colId={isImpactedMaster ? "NetConditionCost" : "NetConditionCost"} pinned='right'></AgGridColumn>
                                <AgGridColumn width={columnWidths?.ConditionCost.revised} cellRenderer='revisedConditionCostFormatter' editable={false} onCellValueChanged='cellChange' field={isImpactedMaster ? "NewNetConditionCost" : "NewNetConditionCost"} headerName="Revised" colId='NewNetConditionCost' pinned='right'></AgGridColumn>
                            </AgGridColumn>
                        }

                        {/* Net Cost Column Group */}
                        <AgGridColumn headerClass="justify-content-center" cellClass="text-center" width={columnWidths?.NetCost?.group} headerName={"Net Cost (Currency)"} marryChildren={true} pinned='right'>
                            <AgGridColumn width={columnWidths?.NetCost?.existing} field={isCostingSimulation ? 'OldRawMaterialIndexationDetails.NetLandedCost' : "OldNetLandedCost"} tooltipField='OldNetLandedCost' editable='false' cellRenderer={'costFormatter'} headerName="Existing" colId='OldNetLandedCost' pinned='right'></AgGridColumn>
                            <AgGridColumn width={columnWidths?.NetCost?.revised} field={isCostingSimulation ? 'NewRawMaterialIndexationDetails.NetLandedCost' : "NewNetLandedCost"} editable='false' cellRenderer={'NewcostFormatter'} headerName="Revised" colId='NewNetLandedCost' pinned='right'></AgGridColumn>
                        </AgGridColumn>

                        {/* Plant Currency Conversion Columns */}
                        {((isRunSimulationClicked && (String(props?.masterId) === String(RMIMPORT) || String(props?.masterId) === String(EXCHNAGERATE))) || isApprovalSummary || props?.isFromApprovalListing) &&
                            <AgGridColumn headerClass="justify-content-center" cellClass="text-center" width={columnWidths?.Currency.withConversion} headerName={`Net Cost (Plant Currency)`} marryChildren={true} pinned='right'>
                                <AgGridColumn width={columnWidths?.Currency.standard} field="OldNetLandedCostLocalConversion" editable='false' headerName="Existing" colId='OldNetLandedCostLocalConversion' cellRenderer='localConversionFormatter' pinned='right'></AgGridColumn>
                                <AgGridColumn width={columnWidths?.Currency.standard} field="NewNetLandedCostLocalConversion" editable='false' headerName="Revised" colId='NewNetLandedCostLocalConversion' cellRenderer='localConversionFormatter' pinned='right'></AgGridColumn>
                            </AgGridColumn>
                        }

                        {/* Exchange Rate Columns */}
                        {(!isImpactedMaster && String(props?.masterId) === String(EXCHNAGERATE)) &&
                            <AgGridColumn suppressSizeToFit="true" field="OldExchangeRate" headerName={`Existing Exchange Rate (Currency)`} minWidth={columnWidths?.OldExchangeRate}></AgGridColumn>
                        }
                        {(!isImpactedMaster && String(props?.masterId) === String(EXCHNAGERATE)) &&
                            <AgGridColumn suppressSizeToFit="true" field="NewExchangeRate" headerName={`Revised Exchange Rate (Currency)`} minWidth={columnWidths?.NewExchangeRate}></AgGridColumn>
                        }

                        {/* Effective Date Columns */}
                        <AgGridColumn minWidth={columnWidths?.NewEffectiveDate} field={isCostingSimulation ? 'OldRawMaterialIndexationDetails.EffectiveDate' : "NewEffectiveDate"} editable='false' cellRenderer={'effectiveDateFormatter'} headerName={isIndexedRM ? props.isImpactedMaster && !props.lastRevision ? "Old Effective date" : "Old Effective Date" : "Effective Date"} ></AgGridColumn>
                        {isIndexedRM &&
                            <AgGridColumn minWidth={columnWidths?.NewEffectiveDate} field={isCostingSimulation ? 'NewRawMaterialIndexationDetails.EffectiveDate' : "NewEffectiveDate"} editable='false' cellRenderer={'effectiveDateFormatter'} headerName={props.isImpactedMaster && !props.lastRevision ? "New Effective date" : "New Effective Date"} ></AgGridColumn>
                        }

                        {/* Action Column */}
                        {(!isImpactedMaster && !isApprovalSummary && !isRunSimulationClicked) && <AgGridColumn width={60} headerName='Action' headerTooltip='Action' pinned='right' cellRenderer='actionCellRenderer'></AgGridColumn>}


                        <AgGridColumn field="RawMaterialId" hide></AgGridColumn>

                        {props.children}
                    </AgGridReact>
                </div>

                {/* Add conditional pagination based on grid type */}
                {paginationProps && (
                    <div className='button-wrapper'>
                        <PaginationWrapper
                            customClass=""
                            gridApi={paginationProps.isSourceGrid ? sourceGridApi : gridApi}
                            globalTake={paginationProps.isSourceGrid ? sourcePageSize : pageSize}
                            setPage={(newSize) => {
                                if (paginationProps.isSourceGrid) {
                                    // Calculate current record index to maintain position
                                    const currentRecordIndex = sourceCurrentPage * sourcePageSize;
                                    const newPageSize = Number(newSize);
                                    const newPage = Math.floor(currentRecordIndex / newPageSize);
                                    const maxPage = Math.ceil(sourceVendorData.length / newPageSize) - 1;
                                    const validPage = Math.min(newPage, maxPage);

                                    setSourcePageSize(newPageSize);
                                    setSourceCurrentPage(validPage);

                                    const start = validPage * newPageSize;
                                    const end = start + newPageSize;
                                    sourceGridApi?.setRowData(sourceVendorData.slice(start, end));
                                } else {
                                    // Calculate current record index to maintain position
                                    const currentRecordIndex = currentPage * pageSize;
                                    const newPageSize = Number(newSize);
                                    const newPage = Math.floor(currentRecordIndex / newPageSize);
                                    const maxPage = Math.ceil(nonSourceVendorData.length / newPageSize) - 1;
                                    const validPage = Math.min(newPage, maxPage);

                                    setPageSize(newPageSize);
                                    setCurrentPage(validPage);

                                    const start = validPage * newPageSize;
                                    const end = start + newPageSize;
                                    gridApi?.setRowData(nonSourceVendorData.slice(start, end));
                                }
                            }}
                        />
                        <PaginationControl
                            pageNo={paginationProps.currentPage + 1}
                            totalRecordCount={paginationProps.totalRecords}
                            pageSize={paginationProps.pageSize}
                            onPreviousClick={() => {
                                const newPage = paginationProps.currentPage - 1;
                                if (newPage >= 0) {
                                    paginationProps.onPageChange(newPage);
                                }
                            }}
                            onNextClick={() => {
                                const newPage = paginationProps.currentPage + 1;
                                const maxPage = Math.ceil(paginationProps.totalRecords / paginationProps.pageSize);
                                if (newPage < maxPage) {
                                    paginationProps.onPageChange(newPage);
                                }
                            }}
                        />

                    </div>
                )}
            </div>
        );
    };

    return (

        <div>
            <div className={`ag-grid-react ${props.customClass}`}>
                {!showverifyPage &&
                    // {(!showverifyPage && !showMainSimulation) &&                    //RE
                    <Fragment>
                        {showTooltip && !isImpactedMaster && !isIndexedRM && <Tooltip className="rfq-tooltip-left" placement={"top"} isOpen={basicRateviewTooltip} toggle={basicRatetooltipToggle} target={"basicRate-tooltip"} >{"To edit revised basic rate please double click on the field."}</Tooltip>}
                        {showTooltip && !isImpactedMaster && !isIndexedRM && <Tooltip className="rfq-tooltip-left" placement={"top"} isOpen={scrapRateviewTooltip} toggle={scrapRatetooltipToggle} target={"scrapRate-tooltip"} >{"To edit revised scrap rate please double click on the field."}</Tooltip>}
                        <Row>
                            <Col className={`${props?.isApprovalSummary ? "" : "add-min-height sm-edit-page"}  mb-3 `}>
                                <div className={`ag-grid-wrapper height-width-wrapper reset-btn-container ${(list && list?.length <= 0) || noData ? "overlay-contain" : ""}`}>
                                    <div className="ag-grid-header d-flex justify-content-between">
                                        <div className='d-flex align-items-center'>

                                            <input type="text" className="form-control mr-1 table-search" id="filter-text-box" value={textFilterSearch} placeholder="Search " autoComplete={'off'} onChange={(e) => onFilterTextBoxChanged(e)} />
                                            <button type="button" className="user-btn float-right mr-3 Tour_List_Reset" title="Reset Grid" onClick={() => resetState()}>
                                                <div className="refresh mr-0"></div>
                                            </button>
                                            {/* <ExcelFile filename={`${props.lastRevision ? 'Last Revision Data' : 'Impacted Master Data'}`} fileExtension={'.xls'} element={
                                                <button title="Download" type="button" className={'user-btn'} ><div className="download mr-0"></div></button>}>
                                                {onBtExport()}
                                            </ExcelFile> */}
                                        </div>
                                        <div className='d-flex justify-content-end'>
                                            {isRunSimulationClicked && list && <div className={`d-flex align-items-center simulation-label-container`}>
                                                <div className='d-flex'>
                                                    <label>Token No: </label>
                                                    <p className='technology ml-1' title={tokenNumber}>{tokenNumber}</p>
                                                </div>

                                            </div>}
                                            {
                                                !props?.isFromApprovalListing && !isApprovalSummary &&
                                                <button type="button" className={"apply  ml-2 back_simulationPage"} id="simulation-back" onClick={() => {
                                                    dispatch(setEffectiveDateRMNonIndexation(null));
                                                    props?.backToSimulation();
                                                }} disabled={isDisable}> <div className={'back-icon'}></div>Back</button>
                                            }
                                        </div>
                                    </div>
                                    <div className="ag-theme-material p-relative" style={{ width: '100%' }}>
                                        {/*  {isLoader && <LoaderCustom />} */}
                                        {noData && <NoContentFound title={EMPTY_DATA} customClassName="no-content-found simulation-lisitng" />}
                                        {indexedRMForSimulation &&
                                            (
                                                (render || isLoader) ? <LoaderCustom customClass="loader-center" /> : (
                                                    <>
                                                        {(props?.isFromApprovalListing || isRunSimulationClicked || isCostingSimulation || isApprovalSummary || isImpactedMaster || sourceVendorData.length === 0) ?
                                                            // For approval/simulation/listing, show all data in single grid
                                                            renderRMTable([...nonSourceVendorData, ...sourceVendorData], true, true) :
                                                            // For editing with source vendor data, show separate grids
                                                            <>
                                                                {/* Non-source vendor grid */}
                                                                {renderRMTable(
                                                                    nonSourceVendorData.slice(currentPage * pageSize, (currentPage + 1) * pageSize),
                                                                    true,
                                                                    true,
                                                                    {
                                                                        currentPage,
                                                                        pageSize,
                                                                        totalRecords: nonSourceVendorData.length,
                                                                        onPageChange: (newPage) => {
                                                                            setCurrentPage(newPage);
                                                                            const start = newPage * pageSize;
                                                                            const end = start + pageSize;
                                                                            gridApi?.setRowData(nonSourceVendorData.slice(start, end));
                                                                        },
                                                                        isSourceGrid: false
                                                                    }
                                                                )}

                                                                {/* Warning message */}
                                                                {!isImpactedMaster && !isApprovalSummary && !isRunSimulationClicked && sourceVendorData.length > 0 && (
                                                                    <div className="text-right">
                                                                        <WarningMessage
                                                                            className="text-right"
                                                                            message="Changing the source vendor data will also impact all associated vendors"
                                                                        />
                                                                    </div>
                                                                )}

                                                                {/* Source vendor grid */}
                                                                {sourceVendorData.length > 0 && renderRMTable(
                                                                    sourceVendorData.slice(sourceCurrentPage * sourcePageSize, (sourceCurrentPage + 1) * sourcePageSize),
                                                                    false,
                                                                    false,
                                                                    {
                                                                        currentPage: sourceCurrentPage,
                                                                        pageSize: sourcePageSize,
                                                                        totalRecords: sourceVendorData.length,
                                                                        onPageChange: (newPage) => {
                                                                            setSourceCurrentPage(newPage);
                                                                            const start = newPage * sourcePageSize;
                                                                            const end = start + sourcePageSize;
                                                                            sourceGridApi?.setRowData(sourceVendorData.slice(start, end));
                                                                        },
                                                                        isSourceGrid: true
                                                                    }
                                                                )}
                                                            </>
                                                        }
                                                    </>
                                                )
                                            )}

                                        {/* {<PaginationWrapper gridApi={gridApi} setPage={onPageSizeChanged} />} */}
                                    </div>
                                </div>

                            </Col>
                        </Row>

                        {
                            !isImpactedMaster && !isApprovalSummary &&
                            <Row className="sf-btn-footer no-gutters justify-content-between bottom-footer">
                                <div className="col-sm-12 text-right bluefooter-butn d-flex justify-content-end align-items-center">
                                    {(!isIndexedRM && !isImpactedMaster && !isApprovalSummary && !isRunSimulationClicked) && <WarningMessage dClass={"mr-4"} message={"Please click on the right icon in the action column to save changes."} />}

                                    {((props.isCostingSimulation || props?.isRMNonIndexSimulation) && !isRunSimulationClicked) && <div className="inputbox date-section mr-3 verfiy-page simulation_effectiveDate">
                                        {<DatePicker
                                            name="EffectiveDate"
                                            id="EffectiveDate"
                                            selected={DayTime(effectiveDate).isValid() ? new Date(effectiveDate) : ''}
                                            onChange={handleEffectiveDateChange}
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode='select'
                                            dateFormat="dd/MM/yyyy"
                                            minDate={new Date(maxDate)}
                                            placeholderText="Select effective date"
                                            className="withBorder"
                                            autoComplete={"off"}
                                            disabledKeyboardNavigation
                                            onChangeRaw={(e) => e.preventDefault()}
                                        />}
                                        {isWarningMessageShow && <WarningMessage dClass={"error-message"} textClass={"pt-1"} message={"Please select effective date"} />}
                                    </div>}
                                    {!isRunSimulationClicked && !isCostingSimulation && <button onClick={(e) => verifySimulation(e, 'run')} type="submit" id="verify-btn" className="user-btn mr5 save-btn verifySimulation" disabled={isDisable}>
                                        <div className={"Run-icon"}>
                                        </div>{" "}
                                        {"Run Simulation"}
                                    </button>}
                                    {isCostingSimulation && <button onClick={(e) => verifySimulation(e, 'verify')} type="submit" id="verify-btn" className="user-btn mr5 save-btn verifySimulation" disabled={isDisable}>
                                        <div className={"Run-icon"}>
                                        </div>{" "}
                                        {"Verify"}
                                    </button>}
                                    {
                                        isRunSimulationClicked &&
                                        <>
                                            {disableSendForApproval && <WarningMessage dClass={"mr-2"} message={sendForApprovalMessage} />}
                                            <button
                                                type="button"
                                                className="user-btn mr5 save-btn"
                                                id={'other_simulation_go_to_history'}
                                                // disabled={((selectedRowData && selectedRowData.length === 0) || isFromApprovalListing) ? true : false}
                                                onClick={() => setShowApprovalHistory(true)}>
                                                <div className={"back-icon"}></div>
                                                {"Go to History"}
                                            </button>
                                            <button
                                                onClick={() => sendForApproval()}
                                                type="submit"
                                                disabled={userDetails()?.Role === 'SuperAdmin' || disableSendForApproval}
                                                id={'other_simulation_send_for_approval'}
                                                title="Send For Approval"
                                                class="user-btn approval-btn mr5">
                                                <div className="send-for-approval">
                                                </div>{" "}
                                                {"Send For Approval"}
                                            </button>
                                        </>
                                    }
                                </div>
                            </Row>
                        }
                    </Fragment>

                }
                {
                    showverifyPage &&
                    <VerifySimulation token={token} cancelVerifyPage={cancelVerifyPage} />
                }
                {(showApprovalHistory || showApprovalHistory) && <Redirect to='/simulation-history' />}

                {
                    showRunSimulationDrawer &&
                    <RunSimulationDrawer
                        isOpen={showRunSimulationDrawer}
                        closeDrawer={closeDrawer}
                        anchor={"right"}
                    />
                }
                {
                    openCommodityDrawer &&
                    <CommoditySimulationDrawer isOpen={openCommodityDrawer} anchor={"right"} closeDrawer={closeCommodityDrawer} commodityDetails={commodityDetailForRow}
                        isViewFlag={isViewFlag} rowData={rowData} />
                }
                {
                    openOtherCostDrawer &&
                    <AddOtherCostDrawer
                        isOpen={openOtherCostDrawer}
                        anchor={"right"}
                        closeDrawer={closeOtherCostDrawer}
                        rawMaterial={true}
                        rmBasicRate={totalBasicRate}
                        ViewMode={isViewFlag}
                        rmTableData={otherCostDetailForRow}
                        rowData={rowData}
                        plantCurrency={rowData?.LocalCurrency}
                        settlementCurrency={rowData?.Currency}
                        RawMaterialNonIndexed={true}
                        disabled={isImpactedMaster || isRunSimulationClicked || isApprovalSummary}
                        disableEditDelete={isSourceVendorDrawer}   // <- important
                        isSimulation={true}
                    />
                }
                {isApprovalDrawer &&
                    <SimulationApproveReject
                        isOpen={isApprovalDrawer}
                        vendorId={''}
                        SimulationTechnologyId={simulationTechnologyId}
                        SimulationType={''}
                        anchor={'right'}
                        approvalData={[]}
                        type={'Sender'}
                        simulationDetail={{ TokenNo: tokenNumber, Status: '', SimulationId: simulationId, SimulationAppliedOn: simulationTechnologyId, EffectiveDate: !isIndexedRM ? effectiveDate : effectiveDate, IsExchangeRateSimulation: false }}
                        selectedRowData={indexedRMForSimulation}
                        costingArr={indexedRMForSimulation}
                        master={selectedMasterForSimulation?.value ? selectedMasterForSimulation?.value : master}
                        closeDrawer={closeApprovalDrawer}
                        isSimulation={true}
                        apiData={indexedRMForSimulation}
                        costingTypeId={simulationHeadId} //CONFIRM FROM ANIKET
                        releaseStrategyDetails={{}}
                        technologyId={simulationTechnologyId}
                        showApprovalTypeDropdown={true}
                        approvalTypeIdValue={simulationHeadId}//CONFIRM FROM ANIKET
                        IsExchangeRateSimulation={selectedMasterForSimulation?.value === EXCHNAGERATE ? true : false}
                        isRMIndexationSimulation={true}
                    // isSaveDone={isSaveDone}
                    />
                }
                {
                    openConditionCostDrawer &&
                    <AddConditionCosting
                        isOpen={openConditionCostDrawer}
                        tableData={conditionCostDetailForRow}
                        closeDrawer={closeConditionCostDrawer}
                        anchor={'right'}
                        basicRateBase={netCostWithoutConditionCost}
                        ViewMode={isImpactedMaster || isViewFlag}
                        isFromMaster={true}
                        isFromImport={true}
                        // EntryType={checkForNull(ENTRY_TYPE_DOMESTIC)}
                        currency={{ label: rowData?.Currency, value: rowData?.CurrencyId }}
                        PlantCurrency={rowData?.LocalCurrency}
                        isImpactedMaster={isImpactedMaster}
                        isSimulation={true}
                        disabled={isImpactedMaster || isRunSimulationClicked || isApprovalSummary}
                    />
                }
            </div>
        </div>
    );
}


export default RMIndexationSimulation;
